(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-avis"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mnl-review-carousel')) {
  class MnlReviewCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.rail = this.querySelector('.mnl-reviews__rail');
      this.cards = Array.from(this.querySelectorAll('.mnl-reviews__item'));
      this.controls = this.querySelector('[data-review-controls]');
      this.previous = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      this.play = this.querySelector('[data-review-play]');
      this.playLabel = this.querySelector('[data-review-play-label]');
      this.position = this.querySelector('[data-review-position]');
      this.positionValue = this.querySelector('[data-review-position-value]');
      this.positionLabel = this.querySelector('[data-review-position-label]');
      this.progress = this.querySelector('[data-review-progress]');
      this.fill = this.querySelector('[data-review-progress-fill]');
      this.status = this.querySelector('[data-review-status]');
      this.summary = this.closest('.mnl-reviews').querySelector('[data-review-summary]');
      if (!this.rail || !this.controls) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay === 'false' || this.motion.matches;
      this.inView = false;
      this.hovered = false;
      this.suspended = false;
      this.index = 0;
      this.stops = [0];
      this.previous.addEventListener('click', () => this.move(this.index - 1, true), {signal});
      this.next.addEventListener('click', () => this.move(this.index + 1, true), {signal});
      this.play.addEventListener('pointerdown', () => { this.playIntent = this.paused; }, {signal});
      this.play.addEventListener('pointercancel', () => { this.playIntent = undefined; }, {signal});
      this.play.addEventListener('blur', () => { this.playIntent = undefined; }, {signal});
      this.play.addEventListener('click', () => {
        this.paused = this.playIntent === undefined ? !this.paused : !this.playIntent;
        this.playIntent = undefined;
        this.update();
        this.schedule();
      }, {signal});
      this.addEventListener('focusin', () => this.pause(), {signal});
      this.rail.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
      }, {signal});
      this.rail.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
      this.rail.addEventListener('pointerdown', () => this.pause(), {signal, passive:true});
      this.rail.addEventListener('wheel', () => this.pause(), {signal, passive:true});
      this.rail.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => { this.update(); this.schedule(); }, 160);
      }, {signal, passive:true});
      this.rail.addEventListener('keydown', event => {
        const targets = {ArrowRight:this.index + 1, ArrowLeft:this.index - 1, Home:0, End:this.stops.length - 1};
        if (!(event.key in targets)) return;
        event.preventDefault();
        this.move(targets[event.key], true);
      }, {signal});
      this.motion.addEventListener('change', () => {
        this.pause();
        if (this.motion.matches) this.rail.scrollTo({left:this.rail.scrollLeft, behavior:'instant'});
        this.measure();
      }, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      window.addEventListener('pagehide', () => {
        this.suspended = true;
        clearTimeout(this.timer);
        clearTimeout(this.scrollTimer);
      }, {signal});
      window.addEventListener('pageshow', () => { this.suspended = false; this.measure(); }, {signal});
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
        this.schedule();
      }, {threshold:0.25});
      this.observer.observe(this);
      this.loadObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.loadObserver.disconnect();
          this.loadReviews();
        }
      }, {rootMargin:'400px'});
      this.loadObserver.observe(this);
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.rail);
      this.measure();
    }
    async loadReviews() {
      if (this.loaded || this.loading) return;
      this.loading = true;
      this.status.hidden = false;
      this.status.textContent = this.dataset.loadingLabel;
      this.rail.setAttribute('aria-busy', 'true');
      const request = new AbortController();
      this.requestController = request;
      const timeout = setTimeout(() => request.abort(), 12000);
      try {
        const response = await fetch('https://mynutrilab-ai.vercel.app/api/feedback?scope=reviews-public&lang=' + encodeURIComponent(this.dataset.lang || 'fr'), {signal:request.signal, cache:'no-store', credentials:'omit'});
        if (!response.ok) throw new Error('reviews-unavailable');
        const data = await response.json();
        if (!data || data.ok !== true || !Array.isArray(data.reviews)) throw new Error('reviews-invalid');
        const seen = new Set();
        const reviews = data.reviews.filter(review => {
          if (!review || typeof review !== 'object' || !Number.isInteger(review.rating) || review.rating < 1 || review.rating > 5 || ![review.body, review.title].some(text => typeof text === 'string' && text.trim())) return false;
          const id = String(review.id || '');
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        }).sort((a, b) => (Date.parse(b.date) || 0) - (Date.parse(a.date) || 0));
        if (data.reviews.length && !reviews.length) throw new Error('reviews-invalid');
        if (!this.isConnected || request.signal.aborted || this.requestController !== request) return;
        const fragment = document.createDocumentFragment();
        reviews.forEach(review => fragment.append(this.buildCard(review)));
        this.rail.replaceChildren(fragment);
        this.cards = Array.from(this.rail.querySelectorAll('.mnl-reviews__item'));
        this.rail.scrollTo({left:0, behavior:'instant'});
        this.loaded = true;
        this.dataset.reviewCount = String(reviews.length);
        this.summary.textContent = this.dataset.countLabel.replace('[count]', reviews.length);
        this.summary.hidden = !reviews.length;
        this.status.textContent = reviews.length ? '' : this.dataset.emptyLabel;
        this.status.hidden = !!reviews.length;
        this.measure();
      } catch (error) {
        if (this.isConnected && this.requestController === request) {
          this.status.textContent = this.dataset.errorLabel;
          this.status.hidden = false;
        }
      } finally {
        clearTimeout(timeout);
        if (this.requestController === request) {
          this.rail.removeAttribute('aria-busy');
          this.requestController = null;
          this.loading = false;
        }
      }
    }
    buildCard(review) {
      const element = (tag, className, text) => {
        const node = document.createElement(tag);
        node.className = className;
        if (text !== undefined) node.textContent = text;
        return node;
      };
      const item = element('li', 'mnl-reviews__item');
      item.dataset.reviewId = String(review.id);
      const card = element('blockquote', 'mnl-reviews__card');
      const top = element('div', 'mnl-reviews__card-top');
      const stars = element('span', 'mnl-reviews__stars', '★'.repeat(review.rating));
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', this.dataset.starsLabel.replace('[rating]', review.rating));
      stars.append(element('span', 'is-empty', '☆'.repeat(5 - review.rating)));
      top.append(stars);
      const date = new Date(review.date);
      if (!Number.isNaN(date.getTime())) {
        const time = element('time', 'mnl-reviews__date', new Intl.DateTimeFormat(this.dataset.lang || 'fr', {day:'numeric', month:'short', year:'numeric'}).format(date));
        time.dateTime = date.toISOString();
        top.append(time);
      }
      card.append(top);
      if (review.title) card.append(element('h3', 'mnl-reviews__review-title', review.title));
      const body = element('p', 'mnl-reviews__quote', review.body || '');
      card.append(body);
      if (body.textContent.length > 260) {
        item.classList.add('is-collapsed');
        this.cardSequence = (this.cardSequence || 0) + 1;
        body.id = this.rail.id + '-review-' + this.cardSequence;
        const more = element('button', 'mnl-reviews__more', this.dataset.moreLabel);
        more.type = 'button';
        more.setAttribute('aria-expanded', 'false');
        more.setAttribute('aria-controls', body.id);
        more.addEventListener('click', () => {
          const expanded = item.classList.toggle('is-collapsed') === false;
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
          this.pause();
        }, {signal:this.controller.signal});
        card.append(more);
      }
      if (review.tr) card.append(element('p', 'mnl-reviews__translated', this.dataset.translatedLabel));
      const footer = element('footer', 'mnl-reviews__author');
      const named = typeof review.name === 'string' && review.name.trim() ? review.name : this.dataset.anonymousLabel;
      const name = review.verified !== true && /^(client vérifié|verified customer)$/i.test(named.trim()) ? this.dataset.anonymousLabel : named;
      const initial = element('span', 'mnl-reviews__initial', Array.from(name)[0].toUpperCase());
      initial.setAttribute('aria-hidden', 'true');
      const identity = document.createElement('div');
      identity.append(element('cite', '', name));
      if (review.verified === true) identity.append(element('span', 'mnl-reviews__verified', '✓ ' + this.dataset.verifiedLabel));
      footer.append(initial, identity);
      card.append(footer);
      item.append(card);
      return item;
    }
    measure() {
      if (!this.cards.length) {
        this.stops = [0];
        this.controls.hidden = true;
        this.progress.hidden = true;
        clearTimeout(this.timer);
        return;
      }
      const max = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      const origin = this.cards[0].getBoundingClientRect().left;
      this.stops = [];
      this.cards.forEach(card => {
        const position = Math.min(max, Math.max(0, card.getBoundingClientRect().left - origin));
        if (!this.stops.some(stop => Math.abs(stop - position) < 2)) this.stops.push(position);
      });
      this.controls.hidden = this.stops.length < 2;
      this.progress.hidden = this.stops.length < 2;
      this.play.hidden = this.motion.matches;
      this.update();
      this.schedule();
    }
    update() {
      if (!this.cards.length) return;
      this.index = this.stops.reduce((closest, stop, index) => Math.abs(stop - this.rail.scrollLeft) < Math.abs(this.stops[closest] - this.rail.scrollLeft) ? index : closest, 0);
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.stops.length - 1;
      this.position.setAttribute('aria-live', this.paused && !this.controls.hidden ? 'polite' : 'off');
      const railBox = this.rail.getBoundingClientRect();
      const visible = this.cards.map((card, index) => ({index, box:card.getBoundingClientRect()})).filter(card => card.box.right > railBox.left + 2 && card.box.left < railBox.right - 2);
      const first = visible.length ? visible[0].index + 1 : 1;
      const last = visible.length ? visible[visible.length - 1].index + 1 : first;
      const range = first === last ? String(first) : first + '–' + last;
      const positionValue = range + ' / ' + this.cards.length;
      const positionLabel = this.dataset.positionLabel.replace('[current]', range).replace('[total]', this.cards.length);
      if (this.positionValue.textContent !== positionValue) this.positionValue.textContent = positionValue;
      if (this.positionLabel.textContent !== positionLabel) this.positionLabel.textContent = positionLabel;
      this.fill.style.width = (last / this.cards.length * 100) + '%';
      this.dataset.playing = String(!this.paused && !this.motion.matches);
      this.playLabel.textContent = this.paused || this.motion.matches ? this.dataset.playLabel : this.dataset.pauseLabel;
    }
    pause() {
      this.paused = true;
      clearTimeout(this.timer);
      this.update();
    }
    move(index, manual) {
      if (manual) this.pause();
      const target = Math.max(0, Math.min(index, this.stops.length - 1));
      this.rail.scrollTo({left:this.stops[target], behavior:this.motion.matches ? 'instant' : 'smooth'});
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.suspended || this.paused || this.motion.matches || !this.inView || this.hovered || document.hidden || this.stops.length < 2) return;
      this.timer = setTimeout(() => {
        this.move(this.index === this.stops.length - 1 ? 0 : this.index + 1, false);
        this.schedule();
      }, 8000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.scrollTimer);
      this.observer?.disconnect();
      this.loadObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.requestController?.abort();
      this.requestController = null;
      this.loading = false;
      this.loaded = false;
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('mnl-review-carousel', MnlReviewCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-configurator-motion"]) return;
  try {
    
if (!customElements.get('mnl-configurator-motion')) {
  customElements.define('mnl-configurator-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.abort && !this.abort.signal.aborted) { this.mount(); return; }
      this.abort?.abort();
      this.abort = new AbortController();
      this.effects = new Map();
      this.values = new WeakMap();
      this.rangeValues = new WeakMap();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mount = this.mount.bind(this);
      const options = { signal:this.abort.signal };
      ['DOMContentLoaded','mnl:config-engine-ready','mnl:recipe-catalog-ready','shopify:section:load'].forEach(name => document.addEventListener(name,this.mount,options));
      window.addEventListener('mnl:config-engine-ready',this.mount,options);
      document.addEventListener('visibilitychange',() => { if (document.hidden) this.stop(); },options);
      this.reduced.addEventListener('change',() => { if (this.reduced.matches) this.stop(); },options);
      this.mount();
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) return;
        this.stop();
        this.abort?.abort();
        this.overlayAbort?.abort();
        this.observer?.disconnect();
        this.stepsObserver?.disconnect();
        this.settingsObserver?.disconnect();
        this.overlay?.removeAttribute('data-mnl-motion');
        this.overlay?.removeAttribute('data-motion-flavor');
        this.overlay = null;
      });
    }
    mount() {
      const overlay = document.getElementById('mnl-overlay');
      if (!overlay || this.overlay === overlay || !overlay.querySelector('.mnl-obj')) return;
      this.stop();
      this.overlayAbort?.abort();
      this.observer?.disconnect();
      this.stepsObserver?.disconnect();
      this.settingsObserver?.disconnect();
      this.overlay?.removeAttribute('data-mnl-motion');
      this.overlay?.removeAttribute('data-motion-flavor');
      this.overlay = overlay;
      this.overlayAbort = new AbortController();
      const options = { signal:this.overlayAbort.signal };
      overlay.setAttribute('data-mnl-motion','20261002');
      const transition = document.getElementById('mnl-pota');
      ['copyFormula','copyFlavor','copyReview'].forEach(key => { if(transition) transition.dataset[key]=this.dataset[key]; });
      this.remember();
      this.syncFlavor();
      overlay.addEventListener('input',event => {
        const range = event.target.closest('input[type="range"]');
        if (!range) return;
        this.pending = range;
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame=0; const target=this.pending; this.pending=null; if(target?.isConnected) this.update(target); });
      },options);
      overlay.addEventListener('pointerdown',event => {
        if (event.target.matches('input[type="range"]')) this.mark(event.target.closest('.mnl-obj'));
      },options);
      ['pointerup','pointercancel','blur'].forEach(name => window.addEventListener(name,() => this.release(),options));
      overlay.addEventListener('focusout',() => this.release(),options);
      overlay.addEventListener('click',event => {
        const flavor = event.target.closest('.mnl-flavor');
        if (flavor) {
          if (this.flavorFrame) cancelAnimationFrame(this.flavorFrame);
          this.flavorFrame = requestAnimationFrame(() => {
            this.flavorFrame=0;
            if (this.overlay !== overlay || !overlay.isConnected || !flavor.isConnected || !overlay.classList.contains('is-open') || document.hidden) return;
            if (!flavor.classList.contains('is-active') || this.selectedFlavor === flavor.dataset.flavor) return;
            this.syncFlavor();
            this.play(flavor.querySelector('img'),[{opacity:.82,transform:'scale(.97)'},{opacity:1,transform:'scale(1)'}],220);
          });
        }
      },options);
      this.observer = new MutationObserver(() => {
        if (!overlay.classList.contains('is-open')) this.stop();
      });
      this.observer.observe(overlay,{attributes:true,attributeFilter:['class']});
      this.settingsObserver = new MutationObserver(records => this.settingsChanged(records));
      this.settingsObserver.observe(overlay,{subtree:true,attributes:true,attributeFilter:['data-config-mode','aria-valuetext']});
      this.activeStep = overlay.querySelector('.mnl-step.is-active')?.dataset.step;
      this.stepsObserver = new MutationObserver(() => this.step());
      overlay.querySelectorAll('.mnl-step[data-step]').forEach(panel => this.stepsObserver.observe(panel,{attributes:true,attributeFilter:['class']}));
    }
    remember() {
      this.overlay.querySelectorAll('[data-act-dose],[data-dose]').forEach(node => this.values.set(node,node.textContent));
      this.overlay.querySelectorAll('input[type="range"]').forEach(range => this.rangeValues.set(range,range.getAttribute('aria-valuetext') || range.value));
    }
    syncFlavor() {
      const selected=this.overlay?.querySelector('.mnl-flavor.is-active');
      this.selectedFlavor=selected?.dataset.flavor || '';
      const keys={'Ice Tea':'ice_tea','Citron Frais':'lemon','Pastèque':'watermelon','Framboise Bleue':'blue_raspberry','Cola':'cola'};
      if(Object.hasOwn(keys,this.selectedFlavor)) this.overlay.dataset.motionFlavor=keys[this.selectedFlavor];
      else this.overlay?.removeAttribute('data-motion-flavor');
    }
    settingsChanged(records) {
      const modeChanged = records.some(record => record.attributeName === 'data-config-mode');
      const rangeChanged = records.some(record => record.attributeName === 'aria-valuetext' && record.target.matches('input[type="range"]'));
      if (!modeChanged && (!rangeChanged || this.pending)) return;
      this.stop();
      this.remember();
    }
    mark(card) {
      if (this.card !== card) this.card?.removeAttribute('data-motion-adjusting');
      this.card = card;
      card?.setAttribute('data-motion-adjusting','');
    }
    release() {
      clearTimeout(this.releaseTimer);
      this.releaseTimer=setTimeout(() => { this.card?.removeAttribute('data-motion-adjusting'); this.card=null; },240);
    }
    update(range) {
      if (!this.overlay.classList.contains('is-open') || document.hidden) return;
      const value = range.getAttribute('aria-valuetext') || range.value;
      const previousValue = this.rangeValues.get(range);
      this.rangeValues.set(range,value);
      if (previousValue === undefined || previousValue === value) return;
      this.mark(range.closest('.mnl-obj'));
      this.release();
      this.overlay.querySelectorAll('[data-act-dose],[data-dose]').forEach(node => {
        const previous=this.values.get(node);
        if (previous !== undefined && previous !== node.textContent) this.play(node,[{opacity:.65,transform:'translateY(2px)'},{opacity:1,transform:'translateY(0)'}],220);
        this.values.set(node,node.textContent);
      });
      const card=range.closest('.mnl-obj');
      this.play(card?.querySelector('.mnl-obj__icon'),[{opacity:.6},{opacity:1}],180);
      if (range.id==='mnl-doses-slider') this.play(this.overlay.querySelector('.mnl-doses-count'),[{opacity:.7,transform:'translateY(2px)'},{opacity:1,transform:'translateY(0)'}],240);
    }
    step() {
      this.syncFlavor();
      const panel=this.overlay.querySelector('.mnl-step.is-active');
      if (!panel || panel.dataset.step===this.activeStep) return;
      const previous=Number(this.activeStep);
      this.activeStep=panel.dataset.step;
      this.stop();
      this.remember();
      if (!this.overlay.classList.contains('is-open')) return;
      const direction=Number(this.activeStep)>previous?1:-1;
      if (direction > 0) this.play(panel.querySelector('.mnl-step__head'),[{opacity:.7},{opacity:1}],200);
    }
    play(node,frames,duration) {
      if (!node?.isConnected || !node.animate || !this.overlay?.contains(node) || this.reduced.matches || document.hidden || !this.overlay?.classList.contains('is-open')) return;
      this.effects.get(node)?.cancel();
      let effect;
      try { effect=node.animate(frames,{duration,easing:'cubic-bezier(.2,.8,.2,1)'}); } catch (_) { return; }
      this.effects.set(node,effect);
      effect.onfinish=() => { if(this.effects.get(node)===effect) this.effects.delete(node); };
    }
    stop() {
      if(this.frame) cancelAnimationFrame(this.frame);
      if(this.flavorFrame) cancelAnimationFrame(this.flavorFrame);
      this.frame=0;
      this.flavorFrame=0;
      this.pending=null;
      clearTimeout(this.releaseTimer);
      this.effects?.forEach(effect => effect.cancel());
      this.effects?.clear();
      this.card?.removeAttribute('data-motion-adjusting');
      this.card=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-configurator-ux-v1525"]) return;
  try {
    
(() => {
  function mount() {
    const overlay = document.getElementById('mnl-overlay');
    const template = document.getElementById('mnl-easy-config-template');
    if (!overlay || !template || overlay.hasAttribute('data-mnl-easy-config')) return;
    const nativeProgress = overlay.querySelector('#mnl-stepper');
    const steps = [...overlay.querySelectorAll('.mnl-step[data-step]')];
    if (!nativeProgress || !steps.length) return;
    const fragment = template.content.cloneNode(true);
    const labelCopy = (window.MNL_CFG_BOOT || {}).labelEditionCopy || {};
    fragment.querySelectorAll('[data-label-copy]').forEach(node => {
      const text = labelCopy[node.dataset.labelCopy];
      if (typeof text === 'string') node.textContent = text;
    });
    const copy = fragment.querySelector('[data-workbench-copy]');
    const options = fragment.querySelector('.mnl-workbench-options');
    const nameIdeas = fragment.querySelector('.mnl-workbench-name-ideas');
    const community = fragment.querySelector('.mnl-workbench-community');
    const progress = fragment.querySelector('.mnl-easy-progress');
    const progressStatus = progress.querySelector('[data-easy-progress-status]');
    const help = fragment.querySelector('.mnl-easy-help');
    const startChoice = fragment.querySelector('.mnl-start-choice');
    const quantities = fragment.querySelector('.mnl-easy-quantities');
    const nameLayout = fragment.querySelector('.mnl-easy-name-layout');
    const nameMeta = fragment.querySelector('.mnl-easy-name-meta');
    const preview = fragment.querySelector('.mnl-easy-preview');
    const reviewActions = fragment.querySelector('.mnl-easy-review-actions');
    const recapGrid = fragment.querySelector('.mnl-recap-grid');
    const recapFacts = fragment.querySelector('.mnl-recap-facts');
    const recapReturn = fragment.querySelector('.mnl-recap-return');
    const recapOffer = fragment.querySelector('.mnl-recap-sticky-note');
    const adjustments = fragment.querySelector('.mnl-studio-adjust');
    const rail = fragment.querySelector('.mnl-studio-rail');
    const wrap = overlay.querySelector('.mnl-pw__wrap');
    const compactPreview = window.matchMedia('(max-width:1099px)');
    const compactFooter = window.matchMedia('(max-width:980px)');
    const journey = rail?.querySelector('[data-context="journey"]');
    const cinemaEvents = new AbortController();
    let compositionEdited = false;
    let openingWhole = true;
    let lastOpen = overlay.classList.contains('is-open');
    let lastActive = Number(overlay.querySelector('.mnl-step.is-active')?.dataset.step || 2);
    let activeGesture = null;
    let editingRecap = false;
    let recapView = 'whole';
    const topbar = overlay.querySelector('.mnl-pw__topbar');
    function updateCinematicTop() {
      const height = Math.ceil(topbar?.getBoundingClientRect().height || 0);
      const value = String(height + 8) + 'px';
      if (height > 0 && overlay.style.getPropertyValue('--mnl-cinematic-top') !== value) overlay.style.setProperty('--mnl-cinematic-top', value);
    }
    const intro = overlay.querySelector('.mnl-obj-intro');
    const slider = overlay.querySelector('#mnl-doses-slider');
    const doseSteps = window.MNL_PRICES && window.MNL_PRICES.DOSE_STEPS;
    if (slider && !Array.isArray(doseSteps)) return;
    const headerObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(updateCinematicTop) : null;
    if (headerObserver && topbar) headerObserver.observe(topbar);
    const current = () => Number((overlay.querySelector('.mnl-step.is-active') || {}).dataset?.step || 2);
    const stepIndex = step => (window.mnlStepOrder ? window.mnlStepOrder() : [2,3,4,5,8,6]).indexOf(Number(step));
    const buttons = [...progress.querySelectorAll('[data-easy-step]')];
    nativeProgress.after(progress);
    const actions = overlay.querySelector('.mnl-pw__topactions');
    if (actions && options) {
      actions.querySelectorAll('.mnl-pw__act-btn').forEach(button => options.querySelector('.mnl-workbench-options__body').append(button));
      actions.prepend(options);
      options.addEventListener('click', event => {
        if (event.target.closest('.mnl-pw__act-btn')) options.open = false;
      });
    }
    const dismissOptions = event => {
      if (!options?.open) return;
      if (event.type === 'keydown' && event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        options.open = false;
        options.querySelector('summary').focus({preventScroll:true});
      } else if (event.type === 'pointerdown' && !options.contains(event.target)) options.open = false;
    };
    document.addEventListener('keydown', dismissOptions, true);
    document.addEventListener('pointerdown', dismissOptions);
    const formulaBody = overlay.querySelector('.mnl-step[data-step="2"] .mnl-step__body');
    if (intro && help) {
      help.append(intro);
      if (formulaBody) formulaBody.prepend(help);
    }
    function setupStartChoice(catalog) {
      const browser = catalog.querySelector('.mnl-recipes__browser');
      if (!startChoice || !browser || catalog.hidden) return;
      const recipesButton = startChoice.querySelector('[data-start-action="recipes"]');
      const customButton = startChoice.querySelector('[data-start-action="custom"]');
      if (!recipesButton || !customButton) return;
      startChoice.hidden = false;
      if (catalog.hasAttribute('data-start-enhanced')) return;
      catalog.setAttribute('data-start-enhanced','');
      if (!browser.id) browser.id = 'mnl-start-recipe-browser';
      recipesButton.setAttribute('aria-controls',browser.id);
      const syncStartChoice = () => {
        recipesButton.setAttribute('aria-expanded',String(browser.open));
        if (!browser.open && browser.contains(document.activeElement)) recipesButton.focus({preventScroll:true});
      };
      browser.addEventListener('toggle',syncStartChoice);
      syncStartChoice();
      recipesButton.addEventListener('click',() => {
        browser.open = !browser.open;
        syncStartChoice();
        if (browser.open) {
          browser.querySelector('summary')?.focus({preventScroll:true});
          catalog.scrollIntoView({block:'start',behavior:'auto'});
        }
      });
      customButton.addEventListener('click',() => {
        const visible = node => Boolean(node && !node.closest('[hidden],[inert],[aria-hidden="true"]') && node.getClientRects().length && window.getComputedStyle(node).visibility !== 'hidden');
        const target = [...formulaBody.querySelectorAll('#mnl-obj-sliders,#mnl-ing-sections')].find(visible);
        if (!target) return;
        browser.open = false;
        syncStartChoice();
        const control = [...target.querySelectorAll('input:not(:disabled),button:not(:disabled),select:not(:disabled),[tabindex="0"]')].find(node => visible(node) && node.getAttribute('aria-disabled') !== 'true');
        if (control) control.focus({preventScroll:true});
        else { target.setAttribute('tabindex','-1'); target.focus({preventScroll:true}); }
        target.scrollIntoView({block:'start',behavior:'auto'});
      });
    }
    function organiseCatalog() {
      const catalog = formulaBody?.querySelector('#mnl-recipe-catalog');
      if (!catalog) return;
      setupStartChoice(catalog);
      if (startChoice && !startChoice.hidden) {
        if (formulaBody.firstElementChild !== startChoice) formulaBody.prepend(startChoice);
        if (startChoice.nextElementSibling !== catalog) startChoice.after(catalog);
      } else if (help?.parentElement === formulaBody) {
        if (help.nextElementSibling !== catalog) help.after(catalog);
      } else if (catalog !== formulaBody.firstElementChild) formulaBody.prepend(catalog);
      if (!catalog.hasAttribute('data-workbench-secondary')) {
        catalog.setAttribute('data-workbench-secondary', '');
        const title = catalog.querySelector('.mnl-recipes__toggle h3');
        if (title && copy?.dataset.catalogTitle) title.textContent = copy.dataset.catalogTitle;
      }
    }
    const catalogObserver = new MutationObserver(organiseCatalog);
    if (formulaBody) catalogObserver.observe(formulaBody, {childList:true});
    organiseCatalog();
    const sticky = document.getElementById('mnl-sticky-atc');
    const stickyPrice = sticky?.querySelector('.mnl-sticky-atc__price');
    if (stickyPrice && recapOffer) {
      recapOffer.hidden = false;
      stickyPrice.append(recapOffer);
    }
    function syncSticky() {
      const style = sticky ? window.getComputedStyle(sticky) : null;
      const visible = Boolean(compactFooter.matches && sticky && sticky.classList.contains('is-visible') && !sticky.hidden && overlay.classList.contains('is-open') && !document.body.classList.contains('mnl-recap-open') && style.display !== 'none' && style.visibility !== 'hidden');
      overlay.toggleAttribute('data-workbench-sticky', visible);
    }
    const stickyObserver = new MutationObserver(syncSticky);
    if (sticky) stickyObserver.observe(sticky, {attributes:true, attributeFilter:['class','style','hidden']});
    stickyObserver.observe(overlay, {attributes:true, attributeFilter:['class']});
    stickyObserver.observe(document.body, {attributes:true, attributeFilter:['class']});
    compactFooter.addEventListener('change', syncSticky);
    function syncProgress() {
      const active = current();
      const open = overlay.classList.contains('is-open');
      if (open && !lastOpen) {
        editingRecap = false;
        recapView = 'whole';
        compositionEdited = false;
        openingWhole = true;
        activeGesture = null;
        journey?.removeAttribute('data-journey-compact');
        journey?.removeAttribute('data-journey-hold-frame');
        journey?.style.removeProperty('--mnl-journey-held-height');
      } else if (active !== lastActive) {
        if (active === 6) editingRecap = false;
        recapView = 'whole';
        openingWhole = false;
        activeGesture = null;
        journey?.removeAttribute('data-journey-hold-frame');
        journey?.style.removeProperty('--mnl-journey-held-height');
      }
      lastOpen = open;
      lastActive = active;
      updateCinematicTop();
      if (overlay.dataset.studioStep !== String(active)) overlay.setAttribute('data-studio-step', String(active));
      if (recapReturn) {
        recapReturn.hidden = !editingRecap || stepIndex(active) < 0 || active === 6;
        recapReturn.disabled = !canReturnToRecap();
      }
      if (rail) {
        const hidden = stepIndex(active) < 0;
        if (rail.hidden !== hidden) rail.hidden = hidden;
        const focus = active === 6 ? recapView : openingWhole ? 'whole' : ({2:compositionEdited ? 'composition' : 'whole',3:'format',4:'flavor',5:'name',8:'whole'})[active] || 'whole';
        journey?.toggleAttribute('data-studio-interactive', active === 6 && open);
        if (journey && journey.dataset.studioFocus !== focus) journey.setAttribute('data-studio-focus', focus);
        const formulaAnchor = formulaBody?.querySelector('#mnl-recipe-catalog') || (help?.parentElement === formulaBody ? help : null);
        const anchor = active === 2 && formulaAnchor ? formulaAnchor : overlay.querySelector('.mnl-step.is-active .mnl-step__head');
        if (active === 6 && recapGrid) { if (rail.parentElement !== recapGrid) recapGrid.prepend(rail); }
        else if (!rail.hidden && compactPreview.matches && anchor && anchor.nextElementSibling !== rail) anchor.after(rail);
        else if ((!compactPreview.matches || rail.hidden) && wrap && rail.parentElement !== wrap) wrap.append(rail);
        if (window.MNLStudioV1502 && typeof window.MNLStudioV1502.boot === 'function') window.MNLStudioV1502.boot(rail);
        journey?.querySelectorAll('[data-recap-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.recapView === recapView)));
      }
      buttons.forEach(button => {
        const step = Number(button.dataset.easyStep);
        const panel = steps.find(node => Number(node.dataset.step) === step);
        button.disabled = stepIndex(step) >= stepIndex(active);
        button.toggleAttribute('data-complete', Boolean(panel?.classList.contains('is-completed')));
        if (step === active) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      if (progressStatus) {
        const ordered = (window.mnlStepOrder ? window.mnlStepOrder() : [2,3,4,5,8,6]).filter(step => buttons.some(button => Number(button.dataset.easyStep) === Number(step)));
        const index = ordered.indexOf(active);
        const selected = buttons.find(button => Number(button.dataset.easyStep) === active);
        progressStatus.hidden = !open || index < 0 || !selected;
        if (!progressStatus.hidden) {
          const label = selected.cloneNode(true);
          label.querySelector('span')?.remove();
          const text = label.textContent.trim() + ' · ' + String(index + 1) + ' / ' + String(ordered.length);
          if (progressStatus.textContent !== text) progressStatus.textContent = text;
          const position = String((index + 1) / ordered.length);
          if (progressStatus.style.getPropertyValue('--mnl-easy-progress') !== position) progressStatus.style.setProperty('--mnl-easy-progress', position);
        }
      }
      if (progress.scrollWidth > progress.clientWidth && progress.dataset.currentStep !== String(active)) {
        const selected = buttons.find(button => Number(button.dataset.easyStep) === active);
        if (selected) {
          const rect = selected.getBoundingClientRect(), viewport = progress.getBoundingClientRect();
          progress.scrollLeft = Math.max(0, progress.scrollLeft + rect.left - viewport.left - (progress.clientWidth - rect.width) / 2);
          progress.dataset.currentStep = String(active);
        }
      }
      syncSticky();
    }
    function canReturnToRecap() {
      const next = overlay.querySelector('#mnl-wiz-next');
      return typeof window.mnlCanReviewFormula === 'function' && window.mnlCanReviewFormula() && (current() === 6 || Boolean(next && !next.disabled));
    }
    function isCompositionControl(target) {
      return Boolean(target?.matches?.('input[type="range"].mnl-obj__slider[data-obj],input[type="range"][data-act-slider],input[type="range"][data-slider]') &&
        overlay.contains(target) && current() === 2 && overlay.classList.contains('is-open') && !target.disabled && target.getAttribute('aria-disabled') !== 'true' && !target.closest('[hidden],[inert],[aria-hidden="true"]'));
    }
    function holdJourneyFrame() {
      if (!journey || journey.dataset.studioFocus !== 'whole' || !compactPreview.matches) return;
      const height = Math.ceil(journey.getBoundingClientRect().height);
      if (height > 0) journey.style.setProperty('--mnl-journey-held-height', String(height) + 'px');
      journey.setAttribute('data-journey-hold-frame','');
    }
    function compositionGesture(event) {
      if (!event.isTrusted || !isCompositionControl(event.target)) return;
      if (event.type === 'pointerdown' && (event.isPrimary === false || (event.button != null && event.button !== 0))) return;
      if (event.type === 'keydown' && !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','PageUp','PageDown'].includes(event.key)) return;
      if (event.type === 'pointerdown') {
        activeGesture = {kind:'pointer',id:event.pointerId};
        holdJourneyFrame();
      }
      if (event.type === 'keydown') activeGesture = {kind:'keyboard'};
      compositionEdited = true;
      openingWhole = false;
      if (!activeGesture) journey?.setAttribute('data-journey-compact','');
      syncProgress();
    }
    function completeCompositionGesture(event) {
      if (!activeGesture || !event.isTrusted) return;
      if (event.type !== 'blur' && ((activeGesture.kind === 'pointer' && event.pointerId !== activeGesture.id) || (activeGesture.kind === 'keyboard' && event.type !== 'keyup'))) return;
      activeGesture = null;
      journey?.setAttribute('data-journey-compact','');
      journey?.removeAttribute('data-journey-hold-frame');
      journey?.style.removeProperty('--mnl-journey-held-height');
    }
    function enterStepPreview(event) {
      if (!openingWhole || !event.isTrusted || current() < 3 || current() > 5) return;
      const control = event.target?.closest?.('#mnl-doses-slider,[data-dose-index],[data-dose-adjust],.mnl-flavor,[data-flavor],#mnl-name,.mnl-name-chip');
      if (!control || !overlay.contains(control) || control.disabled || control.closest('[hidden],[inert],[aria-hidden="true"]')) return;
      if (event.type === 'pointerdown') {
        if (event.isPrimary === false || (event.button != null && event.button !== 0)) return;
        activeGesture = {kind:'pointer',id:event.pointerId};
        holdJourneyFrame();
      }
      openingWhole = false;
      syncProgress();
    }
    ['pointerdown','keydown','input'].forEach(type => overlay.addEventListener(type, compositionGesture, {capture:true,signal:cinemaEvents.signal}));
    ['pointerdown','click','input','change'].forEach(type => overlay.addEventListener(type, enterStepPreview, {capture:true,signal:cinemaEvents.signal}));
    ['pointerup','pointercancel','keyup','blur'].forEach(type => window.addEventListener(type, completeCompositionGesture, {capture:true,signal:cinemaEvents.signal}));
    function focusStepHeading(step) {
      if (current() !== step) return;
      const heading = overlay.querySelector('.mnl-step[data-step="' + step + '"] .mnl-step__head');
      if (heading) heading.focus({preventScroll:true});
    }
    progress.addEventListener('click', event => {
      const button = event.target.closest('[data-easy-step]');
      if (!button || button.disabled) return;
      const step = Number(button.dataset.easyStep);
      if (stepIndex(step) >= 0 && stepIndex(step) < stepIndex(current()) && Number.isInteger(step) && typeof window.mnlOpenStep === 'function') {
        window.mnlOpenStep(step);
        focusStepHeading(step);
      }
    });
    const stepObserver = new MutationObserver(syncProgress);
    steps.forEach(step => stepObserver.observe(step, {attributes:true, attributeFilter:['class']}));
    stepObserver.observe(overlay, {attributes:true, attributeFilter:['class']});
    compactPreview.addEventListener('change', syncProgress);
    const cleanupJourneyLayout = event => {
      if (event.target && event.target.contains(overlay)) {
        compactPreview.removeEventListener('change', syncProgress);
        compactFooter.removeEventListener('change', syncSticky);
        stepObserver.disconnect();
        stickyObserver.disconnect();
        catalogObserver.disconnect();
        cinemaEvents.abort();
        headerObserver?.disconnect();
        document.removeEventListener('keydown', dismissOptions, true);
        document.removeEventListener('pointerdown', dismissOptions);
        document.removeEventListener('shopify:section:unload', cleanupJourneyLayout);
      }
    };
    document.addEventListener('shopify:section:unload', cleanupJourneyLayout);
    const ingredientGroups = overlay.querySelector('#mnl-obj-sliders');
    if (ingredientGroups) {
      const syncIngredientDetails = () => {
        ingredientGroups.querySelectorAll('.mnl-obj[data-obj-row]').forEach((card, index) => {
          const button = card.querySelector('.mnl-obj__expand');
          const group = card.querySelector('.mnl-obj-act');
          if (!button || !group) return;
          if (!group.getAttribute('id')) group.setAttribute('id', 'mnl-easy-actives-' + String(index));
          button.setAttribute('aria-controls', group.getAttribute('id'));
          button.setAttribute('aria-expanded', String(card.classList.contains('is-expanded')));
        });
      };
      const detailsObserver = new MutationObserver(syncIngredientDetails);
      detailsObserver.observe(ingredientGroups, {subtree:true, childList:true, attributes:true, attributeFilter:['class']});
      syncIngredientDetails();
    }
    if (slider && Array.isArray(doseSteps) && doseSteps.length === Number(slider.max) + 1) {
      const syncQuantity = () => {
        quantities.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.doseIndex === slider.value)));
        if (adjustments) adjustments.querySelectorAll('[data-dose-adjust]').forEach(button => {
          const direction = Number(button.dataset.doseAdjust);
          button.disabled = direction < 0 ? Number(slider.value) <= 0 : Number(slider.value) >= doseSteps.length - 1;
        });
      };
      doseSteps.forEach((count, index) => {
        if (![15, 30, 60].includes(count)) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.doseIndex = String(index);
        button.append(document.createTextNode(String(count)));
        const label = document.createElement('small');
        label.textContent = quantities.dataset.doseLabel;
        button.append(label);
        button.addEventListener('click', () => {
          slider.value = String(index);
          slider.dispatchEvent(new Event('input', {bubbles:true}));
          syncQuantity();
        });
        quantities.append(button);
      });
      slider.after(quantities);
      if (adjustments) {
        slider.after(adjustments);
        adjustments.addEventListener('click', event => {
          const button = event.target.closest('[data-dose-adjust]');
          if (!button || button.disabled) return;
          const direction = Number(button.dataset.doseAdjust);
          if (direction !== -1 && direction !== 1) return;
          const index = Math.max(0, Math.min(doseSteps.length - 1, Number(slider.value) + direction));
          slider.value = String(index);
          slider.dispatchEvent(new Event('input', {bubbles:true}));
          syncQuantity();
        });
      }
      const doseBlock = slider.closest('.mnl-doses-block');
      if (doseBlock) {
        doseBlock.setAttribute('data-easy-quantity-buttons', '');
      }
      slider.addEventListener('input', syncQuantity);
      const quantityObserver = new MutationObserver(syncQuantity);
      quantityObserver.observe(slider, {attributes:true, attributeFilter:['aria-valuetext']});
      syncQuantity();
    }
    const nameStep = overlay.querySelector('.mnl-step[data-step="5"]');
    const nameInput = overlay.querySelector('#mnl-name');
    const nameBlock = nameStep && nameStep.querySelector('.mnl-name-block');
    const studio = nameStep && nameStep.querySelector('.mnl-config-studio');
    if (nameStep && nameInput && nameBlock && studio && nameLayout && nameMeta && preview) {
      const title = nameStep.querySelector('.mnl-step__title');
      if (title) title.textContent = nameLayout.dataset.title;
      nameBlock.before(nameLayout);
      nameLayout.append(nameBlock, preview);
      preview.append(studio);
      const namePreview = studio.querySelector('[data-mnl-studio]');
      if (namePreview) namePreview.setAttribute('data-studio-focus', 'name');
      preview.open = false;
      preview.hidden = true;
      const nameRow = nameInput.closest('.mnl-name-block__row');
      if (nameRow) nameRow.after(nameMeta);
      else nameInput.after(nameMeta);
      const describedBy = new Set((nameInput.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      describedBy.add('mnl-easy-name-help');
      nameInput.setAttribute('aria-describedby', [...describedBy].join(' '));
      const counter = nameMeta.querySelector('.mnl-easy-name-count');
      const syncName = () => {
        if (counter) counter.textContent = String(nameInput.value.length) + ' / ' + String(nameInput.maxLength);
      };
      nameInput.addEventListener('input', syncName);
      const nameSummary = nameStep.querySelector('#mnl-step-summary-5');
      if (nameSummary) {
        const nameObserver = new MutationObserver(syncName);
        nameObserver.observe(nameSummary, {childList:true, characterData:true, subtree:true});
      }
      nameStep.setAttribute('data-easy-name-layout', '');
      const chips = nameBlock.querySelector('.mnl-name-chips');
      if (chips && nameIdeas) {
        nameBlock.append(nameIdeas);
        nameIdeas.append(chips);
      }
      syncName();
    }
    const recapSlot = overlay.querySelector('#mnl-recap-slot');
    const recapPreview = overlay.querySelector('.mnl-recap-preview');
    const recapStudio = recapPreview?.closest('[data-mnl-recap-studio]');
    if (recapPreview && recapStudio) {
      recapPreview.open = false;
      recapPreview.hidden = true;
      const recapRoot = recapPreview.querySelector('[data-mnl-studio]');
      if (recapRoot) recapRoot.setAttribute('data-studio-focus', 'whole');
    }
    if (recapSlot && recapGrid && rail && journey && reviewActions) {
      recapSlot.before(recapGrid);
      recapGrid.append(recapSlot);
      journey.querySelector('.mnl-jar-journey__interactive')?.append(reviewActions);
      const purchase = overlay.querySelector('.mnl-side-r__col--right');
      const nativeFacts = purchase?.querySelector('.mnl-side-r__recap');
      if (purchase && recapFacts && nativeFacts) {
        purchase.prepend(recapFacts);
        recapFacts.append(nativeFacts);
        if (recapStudio) recapFacts.append(recapStudio);
      }
      overlay.addEventListener('click', event => {
        const button = event.target.closest('[data-review-step]');
        if (!button || button.disabled || current() !== 6) return;
        const step = Number(button.dataset.reviewStep);
        if (stepIndex(step) < 0 || step === 6 || !Number.isInteger(step) || typeof window.mnlOpenStep !== 'function') return;
        editingRecap = true;
        if (step === 2) compositionEdited = true;
        window.mnlOpenStep(step);
        syncProgress();
        focusStepHeading(step);
      }, {signal:cinemaEvents.signal});
      journey.addEventListener('click', event => {
        const view = event.target.closest('[data-recap-view]');
        if (!view || current() !== 6) return;
        recapView = view.dataset.recapView;
        journey.querySelectorAll('[data-recap-view]').forEach(button => button.setAttribute('aria-pressed', String(button === view)));
        syncProgress();
      }, {signal:cinemaEvents.signal});
      const wizardNav = overlay.querySelector('#mnl-wizard-nav');
      if (wizardNav && recapReturn) wizardNav.before(recapReturn);
      recapReturn?.addEventListener('click', () => {
        if (!editingRecap || stepIndex(current()) < 0 || current() === 6 || !canReturnToRecap() || typeof window.mnlOpenStep !== 'function') return;
        window.mnlOpenStep(6);
        syncProgress();
        focusStepHeading(6);
      }, {signal:cinemaEvents.signal});
      const syncRecapReturn = () => { if (recapReturn) recapReturn.disabled = !canReturnToRecap(); };
      overlay.addEventListener('input', syncRecapReturn, {signal:cinemaEvents.signal});
      overlay.addEventListener('change', syncRecapReturn, {signal:cinemaEvents.signal});
      const nativeNext = overlay.querySelector('#mnl-wiz-next');
      if (nativeNext) stepObserver.observe(nativeNext, {attributes:true, attributeFilter:['disabled']});
    }
    const consent = overlay.querySelector('.mnl-publication-consent');
    const share = overlay.querySelector('.mnl-side-r__share');
    if (consent && share && community && consent.parentElement === share.parentElement) {
      consent.before(community);
      community.append(consent, share);
      options?.querySelector('.mnl-workbench-options__body')?.append(community);
    }
    steps.forEach(step => {
      const title = step.querySelector('.mnl-step__title');
      const text = copy?.getAttribute('data-title-' + step.dataset.step);
      if (title && text) title.textContent = text;
    });
    // Mirror existing rendered values; the native engine remains the sole pricing/cart authority.
    if (wrap && rail) {
      wrap.append(rail);
      if (window.MNLStudioV1502 && typeof window.MNLStudioV1502.boot === 'function') window.MNLStudioV1502.boot(rail);
      const sources = {actives:'#mnl-summary-count', doses:'#mnl-doses-count', flavor:'#mnl-side-r-flavor', price:'#mnl-billing-once-price'};
      Object.entries(sources).forEach(([key, selector]) => {
        const source = overlay.querySelector(selector);
        const target = rail.querySelector('[data-studio-read="' + key + '"]');
        if (!source || !target) return;
        const sync = () => {
          const value = source.textContent.trim() || '—';
          if (target.textContent !== value) target.textContent = value;
        };
        new MutationObserver(sync).observe(source, {childList:true, subtree:true, characterData:true});
        sync();
      });
    }
    overlay.setAttribute('data-mnl-easy-config', '1525');
    overlay.setAttribute('data-mnl-studio-config', '20260920');
    overlay.setAttribute('data-mnl-workbench', '20261002');
    if (journey) overlay.setAttribute('data-mnl-cinematic', '');
    syncProgress();
  }
  function ready() {
    mount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
  document.addEventListener('shopify:section:load', ready);
  window.addEventListener('mnl:recipe-catalog-ready', ready);
  window.addEventListener('load', ready, {once:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-ingredient-details"]) return;
  try {
    
  if (!customElements.get('mnl-ingredient-details')) {
    class MnlIngredientDetails extends HTMLElement {
      connectedCallback() {
        if (this._lifecycle) return;
        this._dialog = this.querySelector('dialog');
        if (!this._dialog) return;
        try { this._copy = JSON.parse(this.querySelector('[data-ingredient-copy]').textContent); }
        catch { return; }
        this._lifecycle = new AbortController();
        const options = { signal: this._lifecycle.signal };
        this.querySelectorAll('[data-ingredient-close]').forEach(button => {
          button.addEventListener('click', () => this.close(), options);
        });
        this._dialog.addEventListener('cancel', event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.close();
        }, options);
        this._dialog.addEventListener('close', () => {
          if (!this._dialog.open) this._finishClose();
        }, options);
        this._dialog.addEventListener('pointerdown', event => {
          this._backdropDown = this._outsideDialog(event);
        }, options);
        this._dialog.addEventListener('click', event => {
          if (this._backdropDown && this._outsideDialog(event)) this.close();
          this._backdropDown = false;
        }, options);
      }

      disconnectedCallback() {
        this.close({ restoreFocus: false });
        this._lifecycle?.abort();
        this._lifecycle = null;
      }

      get open() { return Boolean(this._dialog?.open); }

      show(ingredient, source) {
        if (!this._dialog || !this._copy || !ingredient) return false;
        const entry = this._copy.ingredients?.[ingredient.id];
        if (!entry || typeof this._dialog.showModal !== 'function') return false;
        const wasOpen = this.open;
        if (!wasOpen) this._source = source instanceof HTMLElement ? source : document.activeElement;
        this._write('[data-ingredient-title]', ingredient.name || entry.name);
        this._write('[data-ingredient-summary]', entry.summary);
        ['utility', 'context'].forEach(field => {
          const node = this.querySelector(`[data-ingredient-${field}]`);
          const text = typeof entry[field] === 'string' ? entry[field] : '';
          node.textContent = text;
          node.closest('section').hidden = !text.trim();
        });
        this._write('[data-ingredient-takeaway]', entry.takeaway);
        this._write('[data-ingredient-precautions]', entry.precautions);
        this._write('[data-ingredient-limits]', entry.limits);
        const dose = ingredient.dose === null || ingredient.dose === undefined || ingredient.dose === '' ? NaN : Number(ingredient.dose);
        const max = ingredient.max === null || ingredient.max === undefined || ingredient.max === '' ? NaN : Number(ingredient.max);
        const unit = typeof ingredient.unit === 'string' ? ingredient.unit : '';
        const number = new Intl.NumberFormat(this.dataset.locale || 'fr', { maximumFractionDigits: 3 });
        const amount = Number.isFinite(dose) && dose >= 0
          ? (dose === 0 ? this._copy.notAdded : `${number.format(dose)} ${unit}`.trim())
          : this._copy.unavailable;
        this._write('[data-ingredient-dose]', amount);
        const range = this.querySelector('[data-ingredient-range]');
        range.hidden = !(Number.isFinite(max) && max >= 0);
        range.textContent = this._copy.range.replace('{max}', number.format(max)).replace('{unit}', unit);
        const references = this.querySelector('[data-ingredient-references]');
        references.replaceChildren();
        (entry.sources || []).forEach(reference => {
          let url;
          try { url = new URL(reference.url); } catch { return; }
          if (url.protocol !== 'https:') return;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = url.href;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.textContent = reference.label || this._copy.sourceLabel;
          item.append(link);
          references.append(item);
        });
        this.querySelector('[data-ingredient-sources]').open = false;
        if (wasOpen) {
          this._showMechanism(ingredient.id);
          this._showIllustration(ingredient.id);
          this.querySelector('[data-ingredient-scroll]').scrollTop = 0;
          return true;
        }
        this._parentOverlay = document.getElementById('mnl-overlay');
        if (this._parentOverlay && !this._overlayOpen(this._parentOverlay)) this._parentOverlay = null;
        this._restoreFocus = true;
        try { this._dialog.showModal(); }
        catch { this._source = null; return false; }
        this._showMechanism(ingredient.id);
        this._showIllustration(ingredient.id);
        this.querySelector('[data-ingredient-scroll]').scrollTop = 0;
        this._lockScroll();
        this._openEvents = new AbortController();
        window.addEventListener('keydown', event => {
          if (!this.open) return;
          event.stopImmediatePropagation();
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
          }
        }, { capture: true, signal: this._openEvents.signal });
        if (this._parentOverlay) {
          this._overlayObserver = new MutationObserver(() => {
            if (!this._overlayOpen(this._parentOverlay)) this.close({ restoreFocus: false });
          });
          this._overlayObserver.observe(this._parentOverlay, {
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden', 'inert', 'aria-hidden']
          });
          this._removalObserver = new MutationObserver(() => {
            if (!this._parentOverlay?.isConnected) this.close({ restoreFocus: false });
          });
          this._removalObserver.observe(document.body, { childList: true, subtree: true });
        }
        return true;
      }

      close({ restoreFocus = true } = {}) {
        this._restoreFocus = restoreFocus;
        if (this._dialog?.open) this._dialog.close();
        this._finishClose();
      }

      _finishClose() {
        this._resetMechanism();
        this._resetIllustration();
        this._openEvents?.abort();
        this._openEvents = null;
        this._overlayObserver?.disconnect();
        this._removalObserver?.disconnect();
        this._overlayObserver = null;
        this._removalObserver = null;
        this._unlockScroll();
        const source = this._source;
        this._source = null;
        if (this._restoreFocus && source?.isConnected && !source.closest('[inert], [hidden], [aria-hidden="true"]')) {
          source.focus({ preventScroll: true });
        }
        this._parentOverlay = null;
      }

      _write(selector, text) { this.querySelector(selector).textContent = text || ''; }

      _showMechanism(ingredientId) {
        this._resetMechanism();
        const diagram = this._copy.mechanisms?.[ingredientId];
        if (!this.open || !diagram || !Array.isArray(diagram.steps) || diagram.steps.length !== 3 || !diagram.steps.every(step => step && typeof step.label === 'string' && step.label.trim()) || typeof diagram.limitation !== 'string' || !diagram.limitation.trim() || typeof diagram.kind !== 'string' || !diagram.kind.trim()) return;
        const safeSources = (Array.isArray(diagram.sources) ? diagram.sources : []).filter(source => {
          try { return new URL(source.url).protocol === 'https:' && typeof source.label === 'string' && source.label.trim(); }
          catch { return false; }
        });
        if (!safeSources.length) return;
        this._write('[data-mechanism-kind]', diagram.kind);
        const steps = this.querySelector('[data-mechanism-steps]');
        diagram.steps.forEach((step, index) => {
          const item = document.createElement('li');
          item.className = 'mnl-id-mechanism-step';
          const icon = document.createElement('span');
          icon.className = 'mnl-id-node-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.append(this._mechanismSvg(step.icon));
          const label = document.createElement('span');
          label.className = 'mnl-id-node-label';
          label.textContent = step.label;
          item.append(icon, label);
          if (index < 2) {
            const connector = document.createElement('span');
            connector.className = 'mnl-id-connector';
            connector.setAttribute('aria-hidden', 'true');
            const kind = diagram.connectors?.[index];
            connector.dataset.connector = kind === 'arrow' || kind === 'plus' ? kind : 'line';
            connector.append(this._mechanismSvg(`connector-${connector.dataset.connector}`));
            item.append(connector);
          }
          steps.append(item);
        });
        this._write('[data-mechanism-limit]', diagram.limitation);
        const references = this.querySelector('[data-mechanism-sources]');
        safeSources.forEach(source => {
          const link = document.createElement('a');
          link.href = new URL(source.url).href;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.textContent = source.label;
          references.append(link);
        });
        this.querySelector('[data-ingredient-mechanism]').hidden = false;
        this.querySelector('[data-ingredient-mechanism-fold]').hidden = false;
      }

      _resetMechanism() {
        const fold = this.querySelector('[data-ingredient-mechanism-fold]');
        if (fold) {
          fold.open = false;
          fold.hidden = true;
        }
        const panel = this.querySelector('[data-ingredient-mechanism]');
        if (panel) panel.hidden = true;
        this.querySelector('[data-mechanism-steps]')?.replaceChildren();
        this.querySelector('[data-mechanism-sources]')?.replaceChildren();
        const kind = this.querySelector('[data-mechanism-kind]');
        if (kind) kind.textContent = '';
        const limitation = this.querySelector('[data-mechanism-limit]');
        if (limitation) limitation.textContent = '';
      }

      _mechanismSvg(name) {
        const paths = {
          ingredient: ['M4 13h16l-2 7H6l-2-7Z', 'M7 9h.01M12 6h.01M17 9h.01M12 10h.01'],
          receptor: ['M6 4v5a6 6 0 0 0 12 0V4', 'M12 15v6M8 21h8', 'M10 4a2 2 0 1 0 4 0a2 2 0 1 0-4 0'],
          signal: ['M3 12h4l3-7 4 14 3-7h4'],
          brain: ['M12 5a4 4 0 0 0-7 2 4 4 0 0 0-2 7 4 4 0 0 0 6 5 3 3 0 0 0 3-3V5Z', 'M12 5a4 4 0 0 1 7 2 4 4 0 0 1 2 7 4 4 0 0 1-6 5 3 3 0 0 1-3-3', 'M7 8v3M6 15h3M17 8v3M18 15h-3'],
          muscle: ['M4 17 7 7l4-3 3 2-2 4-3-1-1 5a7 7 0 0 1 11 1l1 3c-5 4-12 3-16-1Z'],
          droplet: ['M12 3c-2 4-7 8-7 12a7 7 0 0 0 14 0c0-4-5-8-7-12Z', 'M8 15a4 4 0 0 0 4 4'],
          mineral: ['m12 3 5 5-5 5-5-5 5-5Z', 'm6 13 4 4-4 4-4-4 4-4Z', 'm18 13 4 4-4 4-4-4 4-4Z'],
          cell: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0', 'M9 12a3 3 0 1 0 6 0a3 3 0 1 0-6 0', 'M6 8h.01M17 16h.01'],
          buffer: ['M12 4v16M5 20h14M4 8h16', 'm4 8-3 6h6l-3-6Zm16 0-3 6h6l-3-6Z'],
          conversion: ['M5 8a8 8 0 0 1 13-2l2 2', 'M15 8h5V3', 'M19 16a8 8 0 0 1-13 2l-2-2', 'M9 16H4v5'],
          liver: ['M3 9c2-4 7-5 11-4l7 2c1 5-3 8-8 8l-5 5-5-2V9Z', 'M14 5v5l-4 5'],
          document: ['M13 3H5v18h14V9l-6-6Z', 'M13 3v6h6M8 13h8M8 17h5'],
          'connector-arrow': ['M4 12h15m-5-5 5 5-5 5'],
          'connector-line': ['M5 12h14'],
          'connector-plus': ['M5 12h14M12 5v14']
        };
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        const connector = typeof name === 'string' && name.startsWith('connector-');
        Object.entries({ viewBox: '0 0 24 24', width: connector ? '16' : '24', height: connector ? '16' : '24', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false' }).forEach(([key, value]) => svg.setAttribute(key, value));
        const commands = Object.prototype.hasOwnProperty.call(paths, name) ? paths[name] : paths.ingredient;
        commands.forEach(command => {
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', command);
          svg.append(path);
        });
        return svg;
      }

      _showIllustration(ingredientId) {
        this._resetIllustration();
        if (!this.open) return;
        const kind = ingredientId === 'pinksalt' ? 'salt' : ingredientId === 'electrolytes' ? 'minerals' : 'powder';
        const illustration = this._copy.illustrations?.[kind];
        if (!illustration?.url) return;
        let url;
        try { url = new URL(illustration.url); } catch { return; }
        if (url.protocol !== 'https:') return;
        const figure = this.querySelector('[data-ingredient-figure]');
        const mount = this.querySelector('[data-ingredient-image-mount]');
        const intro = this.querySelector('[data-ingredient-intro]');
        const image = document.createElement('img');
        this._illustrationImage = image;
        image.className = 'mnl-id-image';
        image.width = 640;
        image.height = 640;
        image.alt = illustration.alt || '';
        image.decoding = 'async';
        image.loading = 'eager';
        image.sizes = '(max-width: 680px) 110px, 150px';
        image.onload = () => {
          if (this._illustrationImage !== image || !this.open) return;
          figure.dataset.imageState = 'ready';
        };
        image.onerror = () => {
          if (this._illustrationImage !== image || !this.open) return;
          this._resetIllustration();
        };
        const atWidth = width => {
          const candidate = new URL(url.href);
          candidate.searchParams.set('width', String(width));
          return candidate.href;
        };
        figure.dataset.imageState = 'loading';
        figure.hidden = false;
        intro.setAttribute('data-illustrated', '');
        mount.replaceChildren(image);
        image.srcset = [320, 480, 640].map(width => `${atWidth(width)} ${width}w`).join(', ');
        image.src = atWidth(320);
      }

      _resetIllustration() {
        const image = this._illustrationImage;
        this._illustrationImage = null;
        if (image) {
          image.onload = null;
          image.onerror = null;
          image.removeAttribute('src');
          image.removeAttribute('srcset');
          image.remove();
        }
        const figure = this.querySelector('[data-ingredient-figure]');
        if (figure) {
          figure.hidden = true;
          delete figure.dataset.imageState;
        }
        this.querySelector('[data-ingredient-intro]')?.removeAttribute('data-illustrated');
      }

      _outsideDialog(event) {
        if (event.target !== this._dialog) return false;
        const rect = this._dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }

      _overlayOpen(overlay) {
        if (!overlay?.isConnected || overlay.hidden || overlay.inert || overlay.getAttribute('aria-hidden') === 'true') return false;
        const style = getComputedStyle(overlay);
        return overlay.classList.contains('is-open') && style.display !== 'none' && style.visibility !== 'hidden';
      }

      _lockScroll() {
        const body = document.body;
        const bodyStyle = getComputedStyle(body);
        const htmlStyle = getComputedStyle(document.documentElement);
        if (this._parentOverlay || /hidden|clip/.test(bodyStyle.overflow + bodyStyle.overflowY + htmlStyle.overflow + htmlStyle.overflowY) || bodyStyle.position === 'fixed') return;
        this._scrollSnapshot = { value: body.style.getPropertyValue('overflow'), priority: body.style.getPropertyPriority('overflow') };
        body.style.setProperty('overflow', 'hidden');
      }

      _unlockScroll() {
        if (!this._scrollSnapshot) return;
        if (this._overlayOpen(document.getElementById('mnl-overlay')) || getComputedStyle(document.body).position === 'fixed') {
          this._scrollSnapshot = null;
          return;
        }
        const style = document.body.style;
        if (style.getPropertyValue('overflow') === 'hidden' && style.getPropertyPriority('overflow') === '') {
          if (this._scrollSnapshot.value) style.setProperty('overflow', this._scrollSnapshot.value, this._scrollSnapshot.priority);
          else style.removeProperty('overflow');
        }
        this._scrollSnapshot = null;
      }
    }
    customElements.define('mnl-ingredient-details', MnlIngredientDetails);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-pp3-video"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__mnlClickVideo) return;
  var mounted=new Map();
  function sourceFor(service,raw){
    try{
      if(typeof raw!=='string'||/[\s\\]/.test(raw)) return null;
      var url=new URL(raw);
      if(url.protocol!=='https:'||url.username||url.password||url.port) return null;
      var host=url.hostname.toLowerCase(),match,id,source,direct;
      if(service==='instagram'&&/^(www\.)?instagram\.com$/.test(host)){
        match=url.pathname.match(/^\/(?:[A-Za-z0-9_.]+\/)?(reel|p|tv)\/([A-Za-z0-9_-]+)\/?$/);
        if(!match) return null;
        direct='https://www.instagram.com/'+match[1]+'/'+match[2]+'/';source=direct+'embed/';
      }else if(service==='tiktok'&&/^(www\.)?tiktok\.com$/.test(host)){
        match=url.pathname.match(/^\/@[A-Za-z0-9_.]+\/video\/(\d{5,25})\/?$/)||url.pathname.match(/^\/player\/v1\/(\d{5,25})\/?$/);
        if(!match) return null;
        id=match[1];direct='https://www.tiktok.com'+url.pathname.replace(/\/$/,'');source='https://www.tiktok.com/player/v1/'+id+'?autoplay=0&loop=0';
      }else if(service==='facebook'&&/^(www\.|m\.)?facebook\.com$/.test(host)){
        match=url.pathname.match(/^\/reel\/(\d+)\/?$/)||url.pathname.match(/^\/(?:[A-Za-z0-9_.]+\/)?videos\/(\d+)\/?$/);
        if(match) direct='https://www.facebook.com'+url.pathname.replace(/\/$/,'')+'/';
        else if(/^\/(watch\/?|video\.php)$/.test(url.pathname)&&/^\d+$/.test(url.searchParams.get('v')||'')) direct='https://www.facebook.com/watch/?v='+url.searchParams.get('v');
        else return null;
        source='https://www.facebook.com/plugins/video.php?href='+encodeURIComponent(direct)+'&show_text=false&autoplay=false';
      }else if(service==='youtube'&&/^(www\.|m\.)?youtube\.com$|^youtu\.be$/.test(host)){
        if(host==='youtu.be') id=url.pathname.slice(1).replace(/\/$/,'');
        else if(url.pathname==='/watch') id=url.searchParams.get('v');
        else {match=url.pathname.match(/^\/(?:embed|shorts)\/([A-Za-z0-9_-]{11})\/?$/);id=match&&match[1];}
        if(!/^[A-Za-z0-9_-]{11}$/.test(id||'')) return null;
        direct='https://www.youtube.com/watch?v='+id;source='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=0&rel=0';
      }else if(service==='file'&&(host==='cdn.shopify.com'||host==='mynutrilab-ai.vercel.app'||host===location.hostname)&&/\.mp4$/i.test(url.pathname)){
        if(host==='cdn.shopify.com'&&!/^\/s\/files\/1\/1012\/8461\/0435\//.test(url.pathname)&&!/^\/videos\//.test(url.pathname)) return null;
        direct=url.href;source=url.href;
      }else return null;
      return {src:source,direct:direct,video:service==='file'};
    }catch(_){return null;}
  }
  function mount(card){
    if(mounted.has(card)) return;
    var button=card.querySelector('[data-video-load]'),close=card.querySelector('[data-video-close]'),frame=card.querySelector('[data-video-frame]'),status=card.querySelector('[data-video-status]'),direct=card.querySelector('[data-video-direct]');
    if(!button||!close||!frame||!status||!direct) return;
    var source=sourceFor(card.dataset.videoService,card.dataset.videoSource);
    var player=null,timer=0,dead=false;
    function stop(restoreFocus){
      clearTimeout(timer);timer=0;
      if(player){player.onload=null;player.onerror=null;if(source.video){player.pause();player.removeAttribute('src');}player.remove();player=null;}
      close.hidden=true;button.hidden=false;button.disabled=!source;card.removeAttribute('aria-busy');card.dataset.videoState='idle';status.textContent='';
      if(restoreFocus) button.focus({preventScroll:true});
    }
    function failed(){
      if(dead||!player) return;
      var restore=document.activeElement===player||document.activeElement===close;
      stop(restore);card.dataset.videoState='error';status.textContent=card.dataset.videoError;
    }
    function activate(){
      if(dead||player||!source) return;
      var media=document.createElement(source.video?'video':'iframe');player=media;
      media.title=card.dataset.videoTitle;media.tabIndex=0;
      if(source.video){media.controls=true;media.playsInline=true;media.preload='none';}
      else{media.allow='encrypted-media; picture-in-picture; fullscreen';media.setAttribute('allowfullscreen','');media.referrerPolicy='strict-origin-when-cross-origin';}
      media.onload=function(){if(dead||player!==media)return;clearTimeout(timer);timer=0;card.removeAttribute('aria-busy');card.dataset.videoState='ready';status.textContent=card.dataset.videoReady;};
      media.onerror=function(){if(player===media)failed();};
      media.src=source.src;button.hidden=true;close.hidden=false;card.dataset.videoState='loading';card.setAttribute('aria-busy','true');status.textContent=card.dataset.videoLoading;
      frame.appendChild(media);media.focus({preventScroll:true});
      if(source.video){card.removeAttribute('aria-busy');card.dataset.videoState='ready';status.textContent=card.dataset.videoReady;}
      else timer=setTimeout(function(){if(player===media)failed();},20000);
    }
    function closePlayer(){stop(true);}
    function destroy(){dead=true;stop(false);button.removeEventListener('click',activate);close.removeEventListener('click',closePlayer);mounted.delete(card);}
    if(source){direct.href=source.direct;button.disabled=false;button.addEventListener('click',activate);close.addEventListener('click',closePlayer);}
    else{card.dataset.videoState='error';status.textContent=card.dataset.videoError;}
    mounted.set(card,{destroy:destroy,stop:stop});
  }
  function boot(scope){
    mounted.forEach(function(controller,card){if(!card.isConnected)controller.destroy();});
    if(scope.matches&&scope.matches('[data-video-card]'))mount(scope);
    if(scope.querySelectorAll)scope.querySelectorAll('[data-mnl-video-section] [data-video-card]').forEach(mount);
  }
  function unload(event){mounted.forEach(function(controller,card){if(event.target===card||event.target.contains(card))controller.destroy();});}
  function hide(event){mounted.forEach(function(controller){if(event.persisted)controller.stop(false);else controller.destroy();});}
  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
  document.addEventListener('shopify:section:unload',unload);
  window.addEventListener('pagehide',hide);
  window.addEventListener('pageshow',function(){boot(document);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);},{once:true});
  window.__mnlClickVideo=true;
  boot(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-recipe-catalog-v1509"]) return;
  try {
    
(function(){
  'use strict';
  var root, copy, details, status, catalog, wrapper, observer, pickerButton, rootClick, linkClick;
  var busy = false, started = false, epoch = 0;
  var order = ['bodybuilder','crossfit','hyrox','football','runner','cyclist','fighter','padel','focus','pump','energy','force','endurance','hydration'];
  var objectives = ['focus','pump','energy','force','endurance','hydration'];
  var productPath = '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres';
  function photo(key){
    var template = root.querySelector('template[data-recipe-photo="' + key + '"]');
    var wrap = template && template.content.firstElementChild ? template.content.firstElementChild.cloneNode(true) : element('div','mnl-recipes__photo');
    wrap.setAttribute('aria-hidden','true');
    var image = wrap.querySelector('img');
    function unavailable(){
      if(image) image.remove();
      wrap.dataset.photoUnavailable = 'true';
    }
    if(image){
      image.addEventListener('error',unavailable,{once:true});
    } else unavailable();
    return wrap;
  }
  function element(tag, className, text){
    var node = document.createElement(tag);
    if(className) node.className = className;
    if(text !== undefined) node.textContent = text;
    return node;
  }
  function api(){ return window.MNL_RECIPE_CATALOG; }
  function number(value){ return new Intl.NumberFormat(document.documentElement.lang || 'fr', {maximumFractionDigits:3}).format(value); }
  function setBusy(value,key){
    busy = value;
    root.setAttribute('aria-busy', String(value));
    root.querySelectorAll('[data-recipe-use]').forEach(function(button){
      button.disabled = value;
      var pending = value && button.dataset.recipeUse === key;
      button.dataset.loading = String(pending);
      button.textContent = pending ? copy.loading : copy.use;
    });
  }
  function sportLabel(recipe){
    return objectives.indexOf(recipe.key) === -1 ? (copy[recipe.key] || recipe.name) : recipe.name;
  }
  function ingredientLabel(dose){
    var ingredients = window.MNL_INGREDIENTS;
    var ing = ingredients && typeof dose.key === 'string' && Object.prototype.hasOwnProperty.call(ingredients,dose.key) ? ingredients[dose.key] : null;
    return ing && typeof ing.label === 'string' && ing.label.trim() ? ing.label : dose.name;
  }
  function card(recipe){
    var item = element('article','mnl-recipes__card');
    item.dataset.recipeKey = recipe.key;
    item.dataset.recipeGroup = objectives.indexOf(recipe.key) >= 0 ? 'objective' : 'sport';
    var head = element('div','mnl-recipes__card-head'); head.appendChild(photo(recipe.key));
    var heading = element('div','mnl-recipes__card-heading');
    if(item.dataset.recipeGroup === 'objective') heading.appendChild(element('p','mnl-recipes__category',copy[recipe.key]));
    var name = element('h4','mnl-recipes__name',sportLabel(recipe));
    name.id = 'mnl-catalog-name-' + recipe.key;
    item.setAttribute('aria-labelledby',name.id);
    heading.appendChild(name); head.appendChild(heading); item.appendChild(head);
    var loaded = element('p','mnl-recipes__loaded',copy.loaded); loaded.hidden = true; item.appendChild(loaded);
    var meta = element('div','mnl-recipes__meta');
    meta.appendChild(element('span','',recipe.doses.length + ' ' + copy.actives));
    var caffeine = recipe.doses.find(function(dose){ return dose.key === 'caffeine'; });
    item.dataset.caffeineFree = String(!caffeine);
    var caffeineMeta = element('span','',caffeine ? copy.caffeine + ' ' + number(caffeine.value) + ' ' + caffeine.unit : copy.no_caffeine);
    if(!caffeine) caffeineMeta.setAttribute('data-caffeine-free','');
    meta.appendChild(caffeineMeta);
    heading.appendChild(meta);
    var composition = element('details','mnl-recipes__composition');
    composition.appendChild(element('summary','',copy.composition));
    var list = element('dl','mnl-recipes__doses');
    recipe.doses.forEach(function(dose){
      var row = element('div','mnl-recipes__dose');
      row.appendChild(element('dt','',ingredientLabel(dose)));
      row.appendChild(element('dd','',number(dose.value) + ' ' + dose.unit));
      list.appendChild(row);
    });
    composition.appendChild(list);
    item.appendChild(composition);
    var button = element('button','mnl-recipes__use',copy.use);
    button.type = 'button'; button.dataset.recipeUse = recipe.key;
    button.setAttribute('aria-label',copy.use + ' : ' + sportLabel(recipe));
    item.appendChild(button);
    return item;
  }
  function matchesFilter(item,group){
    return group === 'all' || (group === 'caffeine-free' ? item.dataset.caffeineFree === 'true' : item.dataset.recipeGroup === group);
  }
  function applyFilter(group){
    var visible = 0;
    root.querySelectorAll('[data-recipe-group]').forEach(function(item){
      item.hidden = !matchesFilter(item,group); if(!item.hidden) visible++;
    });
    root.querySelector('.mnl-recipes__filter-status').textContent = copy.filter_status.replace('{count}',number(visible));
  }
  function openCatalog(){
    if(!started || !api() || !api().isReady() || typeof window.mnlOpenConfig !== 'function') return false;
    if(typeof window.mnlPickerModalClose === 'function') window.mnlPickerModalClose();
    window.mnlOpenConfig();
    if(window.mnlOpenStep) window.mnlOpenStep(2);
    details.open = true;
    document.dispatchEvent(new Event('mnl:pre-release'));
    var mount = epoch;
    requestAnimationFrame(function(){
      if(!started || mount !== epoch) return;
      root.scrollIntoView({block:'start',behavior:'auto'});
      details.querySelector('summary').focus({preventScroll:true});
    });
    return true;
  }
  function rewriteLink(anchor){
    if(!anchor || anchor.tagName !== 'A' || !anchor.hasAttribute('href')) return;
    var url;
    try { url = new URL(anchor.getAttribute('href'),location.href); } catch(_){ return; }
    if(url.origin !== location.origin) return;
    var match = url.pathname.match(/^(\/(?:[a-z]{2}(?:-[a-z]{2})?))?\/pages\/formules\/?$/i);
    if(match){
      url.pathname = (match[1] || '') + productPath;
      url.searchParams.set('open','formulas'); url.hash = '';
      anchor.setAttribute('href',url.pathname + url.search);
    }
    if(url.pathname.endsWith(productPath) && url.searchParams.get('open') === 'formulas') anchor.dataset.mnlRecipeEntry = 'true';
  }
  function rewriteTree(node){
    if(node.nodeType !== 1) return;
    rewriteLink(node);
    node.querySelectorAll('a[href]').forEach(rewriteLink);
  }
  function init(){
    if(started) return;
    root = document.getElementById('mnl-recipe-catalog');
    if(!root || !api() || typeof api().list !== 'function' || typeof api().apply !== 'function' || typeof api().isReady !== 'function' || !api().isReady()) return;
    var target = document.querySelector('.mnl-pw .mnl-step[data-step="2"] .mnl-step__body');
    if(!target) return;
    try {
      copy = JSON.parse(root.querySelector('[data-recipe-copy]').textContent);
      catalog = api().list();
      if(!Array.isArray(catalog) || !catalog.length) return;
    } catch(_){ return; }
    started = true;
    var mount = ++epoch;
    wrapper = root.closest('.shopify-section');
    details = root.querySelector('.mnl-recipes__browser');
    status = root.querySelector('.mnl-recipes__status');
    var grid = root.querySelector('.mnl-recipes__grid');
    order.forEach(function(key){ var recipe = catalog.find(function(item){ return item.key === key; }); if(recipe) grid.appendChild(card(recipe)); });
    root.querySelectorAll('[data-recipe-filter]').forEach(function(button){
      button.setAttribute('aria-pressed',String(button.dataset.recipeFilter === 'all'));
      var count = 0; root.querySelectorAll('[data-recipe-group]').forEach(function(item){ if(matchesFilter(item,button.dataset.recipeFilter)) count++; });
      button.querySelector('[data-filter-count]').textContent = number(count);
    });
    applyFilter('all');
    target.insertBefore(root,target.firstChild); root.hidden = false;
    rootClick = function(event){
      var filter = event.target.closest('[data-recipe-filter]');
      if(filter){
        var group = filter.dataset.recipeFilter;
        root.querySelectorAll('[data-recipe-filter]').forEach(function(button){ button.setAttribute('aria-pressed',String(button === filter)); });
        applyFilter(group);
        return;
      }
      var button = event.target.closest('[data-recipe-use]');
      if(!button || busy) return;
      var recipe = catalog.find(function(item){ return item.key === button.dataset.recipeUse; });
      if(!recipe) return;
      setBusy(true,recipe.key); root.dataset.result = 'loading'; status.textContent = copy.loading;
      Promise.resolve().then(function(){ if(!started || mount !== epoch) return false; return api().apply(recipe.key); }).then(function(applied){
        if(!started || mount !== epoch) return;
        if(applied !== true){ status.textContent = ''; root.removeAttribute('data-result'); return; }
        var legacyNotice = document.getElementById('mnl-recipe-loaded');
        if(legacyNotice) legacyNotice.remove();
        root.dataset.result = 'success';
        root.querySelectorAll('[data-recipe-key]').forEach(function(item){
          var current = item.dataset.recipeKey === recipe.key;
          item.dataset.lastLoaded = String(current); item.querySelector('.mnl-recipes__loaded').hidden = !current;
        });
        details.open = false;
        status.textContent = copy.selected.replace('{name}',sportLabel(recipe));
        status.focus({preventScroll:true});
        root.scrollIntoView({block:'start',behavior:'auto'});
      }).catch(function(){ if(started && mount === epoch) { root.dataset.result = 'error'; status.textContent = copy.error; } }).then(function(){ if(started && mount === epoch) setBusy(false); });
    };
    root.addEventListener('click',rootClick);
    var picker = document.querySelector('#mnl-pickmod .mnl-pickmod__cards');
    if(picker && !picker.querySelector('[data-mnl-recipe-picker]')){
      var pickButton = element('button','mnl-pickmod__card');
      pickButton.type = 'button'; pickButton.dataset.mnlRecipePicker = 'true';
      var text = element('div','mnl-pickmod__card-body');
      text.appendChild(element('h3','',copy.picker_title)); text.appendChild(element('p','',copy.picker_desc));
      pickButton.appendChild(text); pickButton.addEventListener('click',openCatalog); picker.appendChild(pickButton);
      pickerButton = pickButton;
    }
    rewriteTree(document.body);
    linkClick = function(event){
      var anchor = event.target.closest('a[data-mnl-recipe-entry]');
      if(!anchor || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || anchor.target === '_blank') return;
      // V1517: off-product links must navigate to the real product entry point.
      var currentPath = location.pathname.replace(/^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/)/i,'').replace(/\/$/,'');
      if(currentPath !== productPath) return;
      if(openCatalog()) event.preventDefault();
    };
    document.addEventListener('click',linkClick);
    observer = new MutationObserver(function(records){ records.forEach(function(record){ record.addedNodes.forEach(rewriteTree); }); });
    observer.observe(document.body,{childList:true,subtree:true});
    window.mnlOpenRecipeCatalog = openCatalog;
    var params = new URLSearchParams(location.search);
    if(params.get('open') === 'formulas') openCatalog();
  }
  function unload(event){
    if(!started || (event.target !== wrapper && !event.target.contains(root))) return;
    epoch++; started = false; busy = false;
    if(observer) observer.disconnect();
    root.removeEventListener('click',rootClick);
    document.removeEventListener('click',linkClick);
    if(pickerButton) { pickerButton.remove(); pickerButton = null; }
    root.querySelector('.mnl-recipes__grid').replaceChildren();
    root.hidden = true;
    root.removeAttribute('aria-busy');
    root.removeAttribute('data-result');
    status.textContent = '';
    if(wrapper && wrapper.isConnected && event.target !== wrapper) wrapper.appendChild(root);
    else root.remove();
    if(window.mnlOpenRecipeCatalog === openCatalog) delete window.mnlOpenRecipeCatalog;
  }
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',unload);
  window.addEventListener('mnl:recipe-catalog-ready',init);
  if(document.readyState !== 'loading') init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-refresh-article"]) return;
  try {
    
if (!customElements.get('mnl-refresh-article')) {
  customElements.define('mnl-refresh-article', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.controller = new AbortController();
      this.changedHeadings = [];
      const body = this.querySelector('[data-article-content]');
      const nav = this.querySelector('[data-toc]');
      const list = this.querySelector('[data-toc-list]');
      if (!body || !nav || !list) return;
      const headings = [...body.querySelectorAll('h2,h3')].filter((heading) => heading.textContent.trim());
      if (headings.length < 2) return;
      const targets = new Map();
      headings.forEach((heading, index) => {
        const originalId = heading.getAttribute('id');
        const originalTabindex = heading.getAttribute('tabindex');
        if (!heading.id || document.getElementById(heading.id) !== heading) {
          const base = `${this.id}-heading-${index + 1}`;
          let id = base;
          let suffix = 2;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        this.changedHeadings.push({ heading, originalId, originalTabindex });
        targets.set(heading.id, heading);
        const item = document.createElement('li');
        if (heading.tagName === 'H3') item.className = 'mnl-ra__toc-sub';
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        link.dataset.tocLink = heading.id;
        item.append(link);
        list.append(item);
      });
      nav.hidden = false;
      this.classList.add('has-toc');
      nav.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-toc-link]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const target = targets.get(link.dataset.tocLink);
        if (!target) return;
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
        try { window.history.replaceState(window.history.state, '', link.getAttribute('href')); } catch (error) { return; }
      }, { signal: this.controller.signal });
    }
    cleanup() {
      this.controller?.abort();
      this.changedHeadings?.forEach(({ heading, originalId, originalTabindex }) => {
        if (originalId === null) heading.removeAttribute('id');
        else heading.setAttribute('id', originalId);
        if (originalTabindex === null) heading.removeAttribute('tabindex');
        else heading.setAttribute('tabindex', originalTabindex);
      });
      this.changedHeadings = [];
      this.querySelector('[data-toc-list]')?.replaceChildren();
      const nav = this.querySelector('[data-toc]');
      if (nav) nav.hidden = true;
      this.classList.remove('has-toc');
    }
    disconnectedCallback() { this.cleanup(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-refresh-blog"]) return;
  try {
    
if (!customElements.get('mnl-refresh-blog')) {
  customElements.define('mnl-refresh-blog', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const input = this.querySelector('[data-search-input]');
      const ui = this.querySelector('[data-search-ui]');
      if (!input || !ui) return;
      const cards = [...this.querySelectorAll('[data-article-card]')];
      const empty = this.querySelector('[data-search-empty]');
      const status = this.querySelector('[data-search-status]');
      const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
      const searchable = cards.map((card) => ({ card, text: normalize(card.dataset.searchText || '') }));
      const filter = () => {
        const terms = normalize(input.value).split(/\s+/).filter(Boolean);
        let visible = 0;
        searchable.forEach(({ card, text }) => {
          card.hidden = !terms.every((term) => text.includes(term));
          if (!card.hidden) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
        if (status) status.textContent = (status.dataset.countLabel || '').replace('__COUNT__', String(visible));
      };
      input.addEventListener('input', filter, { signal: this.controller.signal });
      this.querySelector('[data-search-clear]')?.addEventListener('click', () => {
        input.value = '';
        filter();
        input.focus();
      }, { signal: this.controller.signal });
      ui.hidden = false;
      filter();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.querySelectorAll('[data-article-card]').forEach((card) => { card.hidden = false; });
      const ui = this.querySelector('[data-search-ui]');
      if (ui) ui.hidden = true;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-refresh-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mnl-refresh-home')) {
  customElements.define('mnl-refresh-home', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.animations = new Set();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => {
        if (!this.motion.matches) return;
        this.observer?.disconnect();
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
      }, { signal: this.controller.signal });
      if (!('IntersectionObserver' in window) || this.motion.matches) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target);
          if (this.motion.matches || typeof entry.target.animate !== 'function') return;
          const animation = entry.target.animate([{ opacity: .86, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 320, easing: 'ease-out' });
          this.animations.add(animation);
          animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
        });
      }, { threshold: .08 });
      this.querySelectorAll('[data-rh-reveal]').forEach(element => this.observer.observe(element));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.animations?.clear();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-single-active-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mnl-single-active-product')) {
    class MnlSingleActiveProduct extends HTMLElement {
      static gramsFromOption(value) {
        const match = String(value ?? '').trim().match(/^(\d+(?:[.,]\d+)?)\s*(kg|g)$/i);
        if (!match) return null;
        const grams = Number(match[1].replace(',', '.')) * (match[2].toLowerCase() === 'kg' ? 1000 : 1);
        return Number.isFinite(grams) && grams > 0 ? grams : null;
      }
      static unitPriceCents(price, grams) {
        if (!Number.isSafeInteger(price) || price < 0 || !Number.isFinite(grams) || grams <= 0) return null;
        return Math.round(price * 100 / grams);
      }
      static matchVariant(variants, options) {
        return variants.find(variant => variant.options.length === options.length && variant.options.every((value, index) => value === options[index])) || null;
      }
      static canPurchase(data, variant) {
        return data?.ready === true && Boolean(variant) && variant.available === true && /^[1-9]\d*$/.test(variant.id) && Array.isArray(data.variants) && data.variants.includes(variant);
      }
      formatMoney(cents) {
        if (!Number.isSafeInteger(cents) || cents < 0) return this.data.messages.noPrice;
        try {
          return new Intl.NumberFormat(this.dataset.locale || 'fr', { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
        } catch { return this.data.messages.noPrice; }
      }
      static imageForVariant(variant, variants = [], images = [], quantityPosition, fallbackId) {
        const hasImage = id => Boolean(id) && images.some(image => image.id === id);
        if (variant && hasImage(variant.imageId)) return variant.imageId;
        if (variant && Number.isInteger(quantityPosition) && quantityPosition >= 0) {
          const sameFlavor = variants.find(candidate => hasImage(candidate.imageId) && candidate.options.length === variant.options.length && candidate.options.every((value, index) => index === quantityPosition || value === variant.options[index]));
          if (sameFlavor) return sameFlavor.imageId;
        }
        return hasImage(fallbackId) ? fallbackId : images[0]?.id || '';
      }
      connectedCallback() {
        if (this.abort) return;
        const source = this.querySelector('[data-product-data]');
        if (!source) return;
        try { this.data = JSON.parse(source.textContent); } catch { return; }
        if (!Array.isArray(this.data.variants) || !Array.isArray(this.data.images)) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.animations = new Set();
        this.elementAnimations = new Map();
        this.imageRequestToken = (this.imageRequestToken || 0) + 1;
        this.quantityGestureStart = null;
        this.groups = [...this.querySelectorAll('[data-option-position]')];
        this.groups.forEach(group => { group.disabled = false; });
        this.setupQuantityControl();
        const galleryControls = this.querySelector('[data-gallery-controls]');
        if (galleryControls) galleryControls.hidden = false;
        this.setupLightbox(signal);
        this.addEventListener('change', event => {
          if (event.target.matches('[data-quantity-range]')) {
            const previous = this.quantityGestureStart ?? this.selectedQuantityGrams();
            const grams = Number(event.target.value);
            this.chooseQuantity(grams);
            this.quantityGestureStart = null;
            if (previous !== null && grams !== previous && this.selectedQuantityGrams() === grams) this.rollQuantity(Math.sign(grams - previous));
            return;
          }
          if (!event.target.matches('[data-option-value]')) return;
          const options = this.groups.map(group => group.querySelector('input:checked')?.value || '');
          this.renderVariant(MnlSingleActiveProduct.matchVariant(this.data.variants, options), options, true);
        }, { signal });
        this.addEventListener('input', event => {
          if (event.target.matches('[data-quantity-range]')) {
            this.quantityGestureStart ??= this.selectedQuantityGrams();
            this.chooseQuantity(Number(event.target.value));
          }
        }, { signal });
        this.addEventListener('click', event => {
          const purchaseButton = event.target.closest('[data-add-to-cart]');
          if (purchaseButton && this.contains(purchaseButton)) {
            event.preventDefault();
            void this.submitPurchase();
            return;
          }
          if (event.target.closest('[data-gallery-open]')) { this.openLightbox(event.target.closest('[data-gallery-open]')); return; }
          if (event.target.closest('[data-gallery-close]')) { this.lightbox?.close(); return; }
          if (event.target.closest('[data-gallery-previous]')) { this.stepLightbox(-1); return; }
          if (event.target.closest('[data-gallery-next]')) { this.stepLightbox(1); return; }
          if (event.target.closest('[data-gallery-retry]')) { this.loadLightboxImage(this.lightboxRequestedId, false); return; }
          if (event.target.closest('[data-smart-next]')) { this.reviewSelection(); return; }
          const preset = event.target.closest('[data-quantity-preset]');
          if (preset && this.contains(preset)) { this.chooseQuantity(Number(preset.dataset.quantityPreset), true); return; }
          const step = event.target.closest('[data-quantity-step]');
          if (step && this.contains(step)) { this.stepQuantity(Number(step.dataset.quantityStep)); return; }
          const button = event.target.closest('[data-image-id]');
          if (button && this.contains(button)) this.showImage(button.dataset.imageId, true);
        }, { signal });
        this.addEventListener('submit', event => {
          if (!event.target.matches('.mnl-sap__form')) return;
          event.preventDefault();
          event.stopPropagation();
          void this.submitPurchase();
        }, { signal });
        this.motion.addEventListener('change', () => {
          if (!this.motion.matches) return;
          const requested = this.requestedImageId;
          this.cancelImageRequest();
          this.stopAnimations();
          if (requested && requested !== this.currentImageId) this.showImage(requested, false);
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.deferredImageId = this.requestedImageId;
            this.cancelImageRequest();
            this.stopAnimations();
            this.lightboxDeferredId = this.lightbox?.open ? this.lightboxRequestedId : null;
            this.cancelLightboxRequest();
          } else if (this.deferredImageId) {
            const requested = this.deferredImageId;
            this.deferredImageId = null;
            this.showImage(requested, false);
          }
          if (!document.hidden && this.lightboxDeferredId && this.lightbox?.open) {
            const requested = this.lightboxDeferredId;
            this.lightboxDeferredId = null;
            this.loadLightboxImage(requested, false);
          }
        }, { signal });
        const selectedOptions = this.groups.map(group => group.querySelector('input:checked')?.value || '');
        if (this.groups.length && selectedOptions.every(Boolean)) {
          this.renderVariant(MnlSingleActiveProduct.matchVariant(this.data.variants, selectedOptions), selectedOptions, false);
        } else {
          const initial = this.data.variants.find(variant => variant.id === this.data.initialVariant) || this.data.variants[0];
          if (initial) {
            this.groups.forEach((group, index) => {
              group.querySelectorAll('input[data-option-value]').forEach(input => {
                input.checked = input.value === initial.options[index];
              });
            });
            this.renderVariant(initial, initial.options, false);
          }
        }
        const purchaseButton = this.querySelector('[data-add-to-cart]');
        if (purchaseButton) purchaseButton.type = 'button';
      }
      setupLightbox(signal) {
        this.lightbox = this.querySelector('[data-gallery-dialog]');
        const trigger = this.querySelector('[data-gallery-open]');
        if (!this.lightbox || !trigger || typeof this.lightbox.showModal !== 'function') return;
        trigger.hidden = !this.data.images.length;
        this.lightbox.addEventListener('close', () => this.resetLightbox(), { signal });
        this.lightbox.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.stepLightbox(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
      }
      lightboxItems() {
        const ids = [...this.querySelectorAll('[data-image-id]')].filter(button => !button.hidden && !button.disabled).map(button => button.dataset.imageId);
        if (this.currentImageId && !ids.includes(this.currentImageId)) ids.unshift(this.currentImageId);
        return [...new Set(ids)].map(id => this.data.images.find(image => image.id === id)).filter(Boolean);
      }
      openLightbox(trigger) {
        const items = this.lightboxItems();
        if (!this.lightbox || !items.length || this.lightbox.open || typeof this.lightbox.showModal !== 'function') return;
        this.lightboxTrigger = trigger;
        try { this.lightbox.showModal(); } catch { this.lightboxTrigger = null; return; }
        this.querySelector('[data-gallery-close]')?.focus({ preventScroll: true });
        this.loadLightboxImage(this.currentImageId || items[0].id, false);
      }
      stepLightbox(direction) {
        if (!this.lightbox?.open) return;
        const items = this.lightboxItems();
        if (items.length < 2) return;
        const index = Math.max(0, items.findIndex(item => item.id === this.lightboxRequestedId));
        this.loadLightboxImage(items[(index + direction + items.length) % items.length].id, true);
      }
      loadLightboxImage(id, animate) {
        const items = this.lightboxItems();
        const item = items.find(image => image.id === id);
        const image = this.querySelector('[data-gallery-dialog-image]');
        if (!this.lightbox?.open || !item || !image) return;
        this.cancelLightboxRequest();
        this.stopLightboxMotion();
        this.lightboxRequestedId = id;
        this.lightboxDeferredId = null;
        this.querySelectorAll('[data-gallery-previous], [data-gallery-next]').forEach(button => { button.disabled = items.length < 2; });
        if (document.hidden) { this.lightboxDeferredId = id; return; }
        this.setLightboxState('loading');
        const token = this.lightboxRequestToken;
        const loader = new Image();
        this.lightboxLoader = loader;
        let decoding = false;
        const current = () => this.isConnected && Boolean(this.abort) && this.lightbox?.open && this.lightboxRequestToken === token && this.lightboxRequestedId === id;
        const failed = () => {
          if (!current()) return;
          loader.onload = loader.onerror = null;
          this.lightboxLoader = null;
          this.setLightboxState('error');
        };
        const loaded = async () => {
          if (decoding || !current()) return;
          decoding = true;
          try {
            if (typeof loader.decode === 'function') await loader.decode();
            if (!current()) return;
            if (!loader.naturalWidth) { failed(); return; }
            loader.onload = loader.onerror = null;
            this.lightboxLoader = null;
            const moving = animate && !image.hidden;
            image.sizes = '(min-width: 1100px) 1060px, calc(100vw - 48px)';
            image.srcset = item.srcset || '';
            image.src = item.src;
            image.width = item.width;
            image.height = item.height;
            image.alt = item.alt || '';
            image.hidden = false;
            this.lightboxImageId = id;
            this.querySelector('[data-gallery-dialog-caption]').textContent = item.alt || '';
            this.querySelector('[data-gallery-dialog-count]').textContent = this.data.messages.galleryCount.replace('[current]', String(items.indexOf(item) + 1)).replace('[total]', String(items.length));
            this.setLightboxState('ready');
            if (moving) this.animateElement(image, [{ opacity: .5, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 220, easing: 'ease-out' });
          } catch { failed(); }
        };
        loader.onload = loaded;
        loader.onerror = failed;
        loader.sizes = '(min-width: 1100px) 1060px, calc(100vw - 48px)';
        loader.srcset = item.srcset || '';
        loader.src = item.src;
        if (loader.complete && loader.naturalWidth) void loaded();
      }
      setLightboxState(state) {
        if (!this.lightbox) return;
        this.lightbox.dataset.state = state;
        this.querySelector('[data-gallery-dialog-media]')?.setAttribute('aria-busy', String(state === 'loading'));
        const status = this.querySelector('[data-gallery-dialog-status]');
        if (status) {
          status.textContent = state === 'loading' ? this.data.messages.galleryLoading : state === 'error' ? this.data.messages.galleryDetailError : '';
          status.hidden = !status.textContent;
        }
        const retry = this.querySelector('[data-gallery-retry]');
        if (retry) retry.hidden = state !== 'error';
      }
      cancelLightboxRequest() {
        this.lightboxRequestToken = (this.lightboxRequestToken || 0) + 1;
        if (this.lightboxLoader) this.lightboxLoader.onload = this.lightboxLoader.onerror = null;
        this.lightboxLoader = null;
      }
      stopLightboxMotion() {
        const image = this.querySelector('[data-gallery-dialog-image]');
        const animation = this.elementAnimations?.get(image);
        if (!animation) return;
        animation.cancel();
        this.animations?.delete(animation);
        this.elementAnimations.delete(image);
      }
      resetLightbox() {
        this.cancelLightboxRequest();
        this.stopLightboxMotion();
        this.lightboxDeferredId = null;
        this.lightboxImageId = null;
        this.lightboxRequestedId = null;
        const image = this.querySelector('[data-gallery-dialog-image]');
        if (image) { image.removeAttribute('srcset'); image.removeAttribute('src'); image.hidden = true; }
        this.setLightboxState('ready');
        const trigger = this.lightboxTrigger;
        this.lightboxTrigger = null;
        if (this.isConnected && trigger?.isConnected) trigger.focus({ preventScroll: true });
      }
      setupQuantityControl() {
        this.quantityControl = null;
        const group = this.groups[Number(this.dataset.quantityPosition) - 1];
        const control = group?.querySelector('[data-quantity-control]');
        const fallback = group?.querySelector('[data-quantity-fallback]');
        if (!control || !fallback) return;
        control.hidden = true;
        fallback.hidden = false;
        const inputs = [...group.querySelectorAll('input[data-option-value]')];
        const values = inputs.map(input => ({ input, grams: MnlSingleActiveProduct.gramsFromOption(input.value) })).sort((a, b) => a.grams - b.grams);
        if (values.length < 2 || values.some(entry => entry.grams === null)) return;
        const minimum = values[0].grams;
        const maximum = values[values.length - 1].grams;
        const step = values[1].grams - minimum;
        if (step !== 50 || values.some((entry, index) => entry.grams !== minimum + index * step)) return;
        const range = control.querySelector('[data-quantity-range]');
        const output = control.querySelector('[data-quantity-output]');
        const less = control.querySelector('[data-quantity-step="-1"]');
        const more = control.querySelector('[data-quantity-step="1"]');
        if (!range || !output || !less || !more) return;
        range.min = String(minimum);
        range.max = String(maximum);
        range.step = String(step);
        control.querySelectorAll('[data-quantity-preset]').forEach(button => {
          button.hidden = !values.some(entry => entry.grams === Number(button.dataset.quantityPreset));
        });
        this.quantityControl = { group, control, fallback, values, range, output, less, more, minimum, maximum };
        control.hidden = false;
        fallback.hidden = true;
      }
      syncQuantityControl(options) {
        const picker = this.quantityControl;
        if (!picker) return;
        const value = options?.[Number(this.dataset.quantityPosition) - 1];
        const entry = picker.values.find(item => item.input.value === value);
        const locked = Boolean(this.submitting || this.purchaseUncertain);
        picker.range.disabled = locked || !entry;
        picker.less.disabled = locked || !entry || entry.grams === picker.minimum;
        picker.more.disabled = locked || !entry || entry.grams === picker.maximum;
        picker.control.querySelectorAll('[data-quantity-preset]').forEach(button => {
          button.disabled = locked || !entry || !picker.values.some(item => item.grams === Number(button.dataset.quantityPreset));
          button.setAttribute('aria-pressed', String(Boolean(entry) && Number(button.dataset.quantityPreset) === entry.grams));
        });
        if (!entry) { picker.output.textContent = '—'; return; }
        const grams = entry.grams;
        picker.range.value = String(grams);
        picker.range.setAttribute('aria-valuetext', grams + ' g');
        picker.range.style.setProperty('--quantity-progress', ((grams - picker.minimum) / (picker.maximum - picker.minimum) * 100) + '%');
        picker.output.textContent = grams === 1000 ? '1 kg' : grams + ' g';
      }
      chooseQuantity(grams, animate = false) {
        const picker = this.quantityControl;
        if (!picker || this.submitting || this.purchaseUncertain) return;
        const entry = picker.values.find(item => item.grams === grams);
        if (!entry) return;
        picker.values.forEach(item => { item.input.checked = item === entry; });
        const options = this.groups.map(group => group.querySelector('input:checked')?.value || '');
        this.renderVariant(MnlSingleActiveProduct.matchVariant(this.data.variants, options), options, animate);
      }
      selectedQuantityGrams() {
        const value = this.quantityControl?.group.querySelector('input:checked')?.value;
        return MnlSingleActiveProduct.gramsFromOption(value);
      }
      rollQuantity(direction) {
        const output = this.quantityControl?.output;
        if (!direction || !output) return;
        this.animateElement(output, [
          { transform: 'translateY(' + (direction * 9) + 'px) scale(.96)', opacity: .78 },
          { transform: 'translateY(' + (direction * -2) + 'px) scale(1.015)', opacity: 1, offset: .7 },
          { transform: 'translateY(0) scale(1)', opacity: 1 }
        ], { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
      stepQuantity(direction) {
        if (direction !== -1 && direction !== 1) return;
        const picker = this.quantityControl;
        const value = picker?.group.querySelector('input:checked')?.value;
        const entry = picker?.values.find(item => item.input.value === value);
        const next = entry && picker.values[picker.values.indexOf(entry) + direction];
        if (next) this.chooseQuantity(next.grams, true);
      }
      renderVariant(variant, options, animate) {
        const previousGrams = this.quantityControl ? Number(this.quantityControl.range.value) : null;
        const price = this.querySelector('[data-price]');
        const unit = this.querySelector('[data-unit-price]');
        const summary = this.querySelector('[data-selection]');
        const error = this.querySelector('[data-selection-error]');
        summary.textContent = this.data.hasOnlyDefaultVariant ? this.data.messages.defaultSelection : options.join(' · ');
        error.hidden = Boolean(variant);
        error.textContent = variant ? '' : this.data.messages.noCombination;
        price.textContent = variant ? this.formatMoney(variant.price) : this.data.messages.noPrice;
        this.dataset.selectedVariant = variant?.id || '';
        this.currentVariant = variant;
        this.syncQuantityControl(options);
        if (!this.submitting && !this.purchaseUncertain) this.setCartStatus('');
        this.updatePurchaseState();
        unit.hidden = true;
        unit.textContent = '';
        const composition = this.querySelector('[data-composition]');
        if (composition) { composition.textContent = ''; composition.hidden = true; }
        const compositionBar = this.querySelector('[data-composition-bar]');
        if (compositionBar) compositionBar.hidden = true;
        const flavor = options.filter((_, index) => index !== Number(this.dataset.quantityPosition) - 1).join(' · ');
        const flavorCaption = this.querySelector('[data-gallery-flavor]');
        if (flavorCaption) { flavorCaption.textContent = this.data.messages.yourFlavor.replace('[flavor]', flavor); flavorCaption.hidden = !flavor; }
        if (variant) {
          const grams = MnlSingleActiveProduct.gramsFromOption(variant.options[Number(this.dataset.quantityPosition) - 1]);
          if (composition && grams !== null) {
            const neutral = variant.options.includes('Neutre');
            const number = new Intl.NumberFormat(this.dataset.locale || 'fr', { maximumFractionDigits: 2 });
            const message = neutral ? this.data.messages.neutralComposition : this.data.messages.flavoredComposition;
            composition.textContent = message.replace('[active]', number.format(neutral ? grams : grams * .8)).replace('[aroma]', number.format(grams * .2));
            composition.hidden = false;
            if (compositionBar) {
              compositionBar.hidden = false;
              compositionBar.style.setProperty('--active-share', neutral ? '100%' : '80%');
            }
          }
          const cents = MnlSingleActiveProduct.unitPriceCents(variant.price, grams);
          if (cents !== null) {
            unit.textContent = this.data.messages.unit.replace('[price]', this.formatMoney(cents));
            unit.hidden = false;
          }
        }
        const imageId = MnlSingleActiveProduct.imageForVariant(variant, this.data.variants, this.data.images, Number(this.dataset.quantityPosition) - 1, this.data.defaultImageId);
        if (imageId) {
          const jar = this.querySelector('[data-selected-jar]');
          const item = this.data.images.find(image => image.id === imageId);
          const summaryImage = this.querySelector('.mnl-sap__summary-image');
          if (summaryImage && item) { summaryImage.removeAttribute('srcset'); summaryImage.src = item.thumbnailSrc || item.src; }
          if (jar && item) {
            jar.dataset.imageId = imageId;
            const thumbnail = jar.querySelector('img');
            if (thumbnail) { thumbnail.srcset = item.srcset; thumbnail.src = item.src; thumbnail.width = item.width; thumbnail.height = item.height; }
          }
          this.showImage(imageId, animate);
        }
        const grams = this.selectedQuantityGrams();
        if (animate && previousGrams !== null && grams !== null && grams !== previousGrams) this.rollQuantity(Math.sign(grams - previousGrams));
        this.syncSmartReview(options);
      }
      syncSmartReview(options) {
        const review = this.querySelector('[data-smart-review]');
        if (!review) return;
        const quantityIndex = Number(this.dataset.quantityPosition) - 1;
        const format = options[quantityIndex] || '';
        const flavor = options.filter((_, index) => index !== quantityIndex).join(' · ');
        review.querySelector('[data-smart-format]').textContent = format;
        review.querySelector('[data-smart-format-row]').hidden = !format;
        review.querySelector('[data-smart-flavor]').textContent = flavor;
        review.querySelector('[data-smart-flavor-row]').hidden = !flavor;
        review.querySelector('[data-smart-price]').textContent = this.querySelector('[data-price]')?.textContent || '';
        review.querySelector('[data-smart-next]').disabled = false;
        review.hidden = false;
      }
      reviewSelection() {
        const summary = this.querySelector('.mnl-sap__selection');
        const button = this.querySelector('[data-add-to-cart]:not(:disabled)');
        summary?.scrollIntoView?.({ behavior: this.motion.matches ? 'auto' : 'smooth', block: 'center' });
        button?.focus({ preventScroll: true });
      }
      updatePurchaseState() {
        const allowed = MnlSingleActiveProduct.canPurchase(this.data, this.currentVariant);
        const locked = Boolean(this.submitting || this.purchaseUncertain);
        const button = this.querySelector('[data-add-to-cart]');
        const input = this.querySelector('[data-variant-input]');
        const label = this.querySelector('[data-cta-label]');
        const availability = this.querySelector('[data-availability]');
        if (input) {
          input.value = this.currentVariant?.id || '';
          input.disabled = !allowed || locked;
        }
        if (button) {
          button.disabled = !allowed || locked;
          button.setAttribute('aria-disabled', String(button.disabled));
          button.setAttribute('aria-busy', String(Boolean(this.submitting)));
        }
        if (label) label.textContent = this.submitting ? this.data.messages.adding : this.data.ready !== true ? this.data.messages.pending : allowed ? this.data.messages.add : this.currentVariant ? this.data.messages.soldOut : this.data.messages.noCombination;
        if (availability) availability.textContent = this.data.ready !== true ? this.data.messages.preparation : !this.currentVariant ? this.data.messages.noCombination : allowed ? this.data.messages.available : this.data.messages.soldOut;
        this.groups?.forEach(group => { group.disabled = locked; });
        if (this.quantityControl) this.syncQuantityControl(this.groups.map(group => group.querySelector('input:checked')?.value || ''));
      }
      setCartStatus(message, showLink = false) {
        const status = this.querySelector('[data-cart-status]');
        const link = this.querySelector('[data-cart-link]');
        if (status) status.textContent = message;
        if (link) link.hidden = !showLink;
      }
      async submitPurchase() {
        if (this.submitting || this.purchaseUncertain) return;
        const options = this.groups?.map(group => group.querySelector('input:checked')?.value || '') || [];
        const variant = this.groups?.length ? MnlSingleActiveProduct.matchVariant(this.data.variants, options) : this.data.hasOnlyDefaultVariant ? this.currentVariant : null;
        if (!MnlSingleActiveProduct.canPurchase(this.data, variant)) {
          this.currentVariant = variant;
          this.updatePurchaseState();
          this.setCartStatus(this.data.ready !== true ? this.data.messages.preparation : variant ? this.data.messages.soldOut : this.data.messages.noCombination);
          return;
        }
        this.currentVariant = variant;
        this.submitting = true;
        this.updatePurchaseState();
        this.setCartStatus(this.data.messages.adding);
        const requestAbort = new AbortController();
        const lifecycleSignal = this.abort?.signal;
        const abortRequest = () => requestAbort.abort();
        if (lifecycleSignal?.aborted) abortRequest();
        else lifecycleSignal?.addEventListener('abort', abortRequest, { once: true });
        const requestTimeout = setTimeout(abortRequest, 15000);
        try {
          const response = await fetch(this.data.routes.add, {
            method: 'POST', credentials: 'same-origin', signal: requestAbort.signal,
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: { _mnl_product_type: 'single_active', _mnl_schema_version: '1' } }] })
          });
          if (!response.ok) {
            if (response.status >= 500) throw new Error('Uncertain cart result');
            this.submitting = false;
            this.updatePurchaseState();
            this.setCartStatus(this.data.messages.cartError, true);
            return;
          }
          const result = await response.json();
          if (!Array.isArray(result.items) || !result.items.some(item => String(item.variant_id || item.id) === variant.id && Number.isInteger(item.quantity) && item.quantity >= 1)) throw new Error('Unconfirmed cart result');
          this.setCartStatus(this.data.messages.added, true);
          try {
            document.dispatchEvent(new CustomEvent('mnl:cart:add-confirmed', { detail: {
              source: 'single-active',
              items: result.items.filter(item => String(item.variant_id || item.id) === variant.id).map(item => ({ key: item.key, variantId: String(item.variant_id || item.id) })),
              buttons: [this.querySelector('[data-add-to-cart]')].filter(Boolean),
              message: this.data.messages.feedbackAdded,
              announce: false
            } }));
          } catch {}
          window.location.assign(this.data.routes.cart);
        } catch {
          this.submitting = false;
          this.purchaseUncertain = true;
          this.updatePurchaseState();
          this.setCartStatus(this.data.messages.cartUncertain, true);
        } finally {
          clearTimeout(requestTimeout);
          lifecycleSignal?.removeEventListener('abort', abortRequest);
        }
      }
      showImage(id, animate) {
        const item = this.data.images.find(image => image.id === id);
        const image = this.querySelector('.mnl-sap__image');
        if (!item || !image) return;
        const previousRequestedId = this.requestedImageId;
        this.requestedImageId = id;
        this.deferredImageId = document.hidden ? id : null;
        this.dataset.requestedImage = id;
        if (previousRequestedId === id && (this.imageLoader || this.currentImageId === id)) return;
        this.cancelImageRequest();
        this.stopImageMotion();
        if (this.currentImageId === id) { this.setGalleryState('ready'); return; }
        if (!this.currentImageId) { this.commitImage(item, image, false); return; }
        if (document.hidden) { this.deferredImageId = id; return; }
        const token = this.imageRequestToken;
        const loader = new Image();
        this.imageLoader = loader;
        this.setGalleryState('loading');
        let decoding = false;
        const current = () => this.isConnected && Boolean(this.abort) && this.imageRequestToken === token && this.requestedImageId === id;
        const failed = () => {
          if (!current()) return;
          loader.onload = loader.onerror = null;
          this.imageLoader = null;
          this.setGalleryState('error');
        };
        const loaded = async () => {
          if (decoding || !current()) return;
          decoding = true;
          try {
            if (typeof loader.decode === 'function') await loader.decode();
            if (!current()) return;
            if (!loader.naturalWidth) { failed(); return; }
            loader.onload = loader.onerror = null;
            this.imageLoader = null;
            this.commitImage(item, image, animate);
          } catch { failed(); }
        };
        loader.onload = loaded;
        loader.onerror = failed;
        loader.sizes = image.sizes;
        loader.srcset = item.srcset || '';
        loader.src = item.src;
        if (loader.complete && loader.naturalWidth) void loaded();
      }
      commitImage(item, image, animate) {
        const previousIndex = this.data.images.findIndex(candidate => candidate.id === this.currentImageId);
        const nextIndex = this.data.images.indexOf(item);
        const direction = nextIndex >= previousIndex ? 1 : -1;
        const moving = animate && !this.motion.matches && !document.hidden && typeof image.animate === 'function';
        let outgoing;
        if (moving && image.complete && image.naturalWidth) {
          outgoing = image.cloneNode(false);
          outgoing.classList.add('mnl-sap__image--outgoing');
          outgoing.removeAttribute('id');
          outgoing.setAttribute('aria-hidden', 'true');
          outgoing.alt = '';
          outgoing.fetchPriority = 'low';
          image.parentElement.append(outgoing);
          this.outgoingImage = outgoing;
        }
        image.srcset = item.srcset || '';
        image.src = item.src;
        image.alt = item.alt;
        image.width = item.width;
        image.height = item.height;
        this.currentImageId = item.id;
        this.dataset.displayedImage = item.id;
        this.setGalleryState('ready');
        if (!moving) return;
        this.animateElement(image, [
          { transform: 'translateX(' + (direction * 20) + 'px) scale(1.012)', opacity: outgoing ? .55 : 1 },
          { transform: 'translateX(0) scale(1)', opacity: 1 }
        ], { duration: 220, easing: 'cubic-bezier(.2,.7,.2,1)' });
        if (outgoing) this.animateElement(outgoing, [
          { transform: 'translateX(0) scale(1)', opacity: 1 },
          { transform: 'translateX(' + (direction * -16) + 'px) scale(.992)', opacity: 0 }
        ], { duration: 200, easing: 'cubic-bezier(.2,.7,.2,1)' }, () => {
          outgoing.remove();
          if (this.outgoingImage === outgoing) this.outgoingImage = null;
        });
      }
      setGalleryState(state) {
        this.dataset.imageState = state;
        this.querySelector('.mnl-sap__stage')?.setAttribute('aria-busy', String(state === 'loading'));
        this.querySelectorAll('[data-image-id]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.imageId === this.currentImageId));
          button.setAttribute('aria-busy', String(state === 'loading' && button.dataset.imageId === this.requestedImageId));
        });
        const status = this.querySelector('[data-gallery-status]');
        if (!status) return;
        const message = state === 'loading' ? this.data.messages.galleryLoading : state === 'error' ? this.data.messages.galleryError : '';
        if (status.textContent !== message) status.textContent = message;
        status.hidden = !message;
      }
      cancelImageRequest() {
        this.imageRequestToken = (this.imageRequestToken || 0) + 1;
        if (this.imageLoader) this.imageLoader.onload = this.imageLoader.onerror = null;
        this.imageLoader = null;
      }
      stopImageMotion() {
        const image = this.querySelector('.mnl-sap__image');
        [image, this.outgoingImage].filter(Boolean).forEach(element => {
          const animation = this.elementAnimations?.get(element);
          if (!animation) return;
          animation.cancel();
          this.animations?.delete(animation);
          this.elementAnimations.delete(element);
        });
        this.outgoingImage?.remove();
        this.outgoingImage = null;
      }
      animateElement(element, frames, timing, cleanup) {
        if (!element || this.motion.matches || document.hidden || !element.animate) return;
        const previous = this.elementAnimations.get(element);
        if (previous) {
          previous.cancel();
          this.animations.delete(previous);
        }
        const animation = element.animate(frames, timing);
        this.animations.add(animation);
        this.elementAnimations.set(element, animation);
        const finish = () => {
          this.animations.delete(animation);
          if (this.elementAnimations.get(element) === animation) this.elementAnimations.delete(element);
          cleanup?.();
        };
        animation.finished.then(finish, finish);
      }
      stopAnimations() {
        this.animations?.forEach(animation => animation.cancel());
        this.animations?.clear();
        this.elementAnimations?.clear();
        this.outgoingImage?.remove();
        this.outgoingImage = null;
      }
      disconnectedCallback() {
        if (this.lightbox?.open) this.lightbox.close();
        this.resetLightbox();
        this.abort?.abort();
        this.abort = null;
        const purchaseButton = this.querySelector('[data-add-to-cart]');
        if (purchaseButton) purchaseButton.type = 'submit';
        this.cancelImageRequest();
        this.deferredImageId = null;
        this.quantityGestureStart = null;
        this.stopAnimations();
      }
    }
    customElements.define('mnl-single-active-product', MnlSingleActiveProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-studio-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mnl-studio-home')){
  customElements.define('mnl-studio-home',class extends HTMLElement{
    connectedCallback(){
      this._events?.abort();this._observer?.disconnect();this._animations?.forEach(animation=>animation.cancel());this._events=new AbortController();this._animations=new Set();
      const signal=this._events.signal;
      const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      if(!motion.matches&&'IntersectionObserver' in window){
        this._observer?.disconnect();
        this._observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
          if(signal.aborted||!this.isConnected||motion.matches||!entry.isIntersecting)return;
          const animation=entry.target.animate([{opacity:.7,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:420,easing:'cubic-bezier(.2,.65,.3,1)'});
          this._animations.add(animation);animation.finished.then(()=>this._animations.delete(animation),()=>this._animations.delete(animation));
          this._observer.unobserve(entry.target);
        }),{threshold:.08});
        this.querySelectorAll('.mnl-sh__section-head,.mnl-sh__step').forEach(el=>this._observer.observe(el));
        motion.addEventListener('change',()=>{if(motion.matches){this._observer?.disconnect();this._animations.forEach(animation=>animation.cancel());this._animations.clear();}},{signal:this._events.signal});
      }
    }
    disconnectedCallback(){this._events?.abort();this._observer?.disconnect();this._animations?.forEach(animation=>animation.cancel());this._animations?.clear();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnl-workout-draft-product"]) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const allowedProducts = {intra:'16312862835075',post:'16312862933379'};
  const expectedFormats = ['15 doses','30 doses','60 doses'];
  const expectedFlavors = ['Citron Frais','Pastèque','Ice Tea','Framboise Bleue','Cola'];
  function mount(root) {
    if (instances.has(root)) return;
    const dataNode = root.querySelector('[data-workout-data]');
    if (!dataNode) return;
    const error = root.querySelector('[data-workout-error]');
    let data;
    const controls = [...root.querySelectorAll('button,input')];
    const showError = message => { error.textContent = message; error.hidden = false; };
    try {
      data = JSON.parse(dataNode.textContent);
      const ids = new Set(), options = new Set();
      if (allowedProducts[data.kind] !== data.productId || root.dataset.productId !== data.productId || root.dataset.workoutKind !== data.kind || data.formatIndex !== 0 || data.flavorIndex !== 1 || !Array.isArray(data.variants) || data.variants.length !== 15 || !data.copy || !['invalid','selectFormat','selectFlavor','enterName','namePlaceholder','chooseFlavor','chooseFormat'].every(key => typeof data.copy[key] === 'string' && data.copy[key].length > 0)) throw new Error('Invalid draft');
      data.variants.forEach(variant => {
        if (!/^\d+$/.test(variant.id) || ids.has(variant.id) || !Array.isArray(variant.options) || variant.options.length !== 2 || !expectedFormats.includes(variant.options[0]) || !expectedFlavors.includes(variant.options[1]) || !Number.isInteger(variant.priceCents) || variant.priceCents <= 0 || typeof variant.priceLabel !== 'string' || !variant.priceLabel.trim()) throw new Error('Invalid variant');
        const key = JSON.stringify(variant.options);
        if (options.has(key)) throw new Error('Duplicate variant');
        ids.add(variant.id); options.add(key);
      });
      [['format',expectedFormats],['flavor',expectedFlavors]].forEach(([kind,values]) => {
        const inputs = [...root.querySelectorAll('[data-workout-option="'+kind+'"]')];
        if (inputs.length !== values.length || !values.every(value => inputs.filter(input => input.value === value).length === 1)) throw new Error('Invalid options');
      });
    } catch (_) {
      controls.forEach(control => { control.disabled = true; });
      root.dataset.ready = 'false';
      showError(root.dataset.workoutInvalid);
      return;
    }
    const controller = new AbortController();
    instances.set(root,controller);
    const steps = [...root.querySelectorAll('[data-workout-step]')];
    const nameInput = root.querySelector('[data-workout-name]');
    let step = 1;
    const choice = kind => root.querySelector('[data-workout-option="'+kind+'"]:checked')?.value || '';
    const nameValue = () => nameInput.value.replace(/\s+/g,' ').trim();
    const variantValue = () => data.variants.find(variant => variant.options[data.formatIndex] === choice('format') && variant.options[data.flavorIndex] === choice('flavor')) || null;
    const validName = () => nameValue().length > 0 && nameValue().length <= 24;
    const allowedStep = () => !choice('format') ? 1 : !variantValue() ? 2 : !validName() ? 3 : 4;
    const text = (selector,value) => { const element = root.querySelector(selector); if (element) element.textContent = value; };
    function sync() {
      const variant = variantValue(), name = nameValue();
      text('[data-workout-label-name]',name || data.copy.namePlaceholder);
      text('[data-workout-label-flavor]',choice('flavor') || data.copy.chooseFlavor);
      text('[data-workout-label-format]',choice('format') || data.copy.chooseFormat);
      const recap = {format:choice('format'),flavor:choice('flavor'),name,variant:variant?.id,price:variant?.priceLabel};
      Object.entries(recap).forEach(([key,value]) => text('[data-workout-recap="'+key+'"]',value || '—'));
      if (variant) root.dataset.selectedVariant = variant.id;
      else delete root.dataset.selectedVariant;
      root.querySelectorAll('[data-workout-goto]').forEach(button => {
        const target = Number(button.dataset.workoutGoto);
        button.disabled = target > allowedStep();
        if (target === step) button.setAttribute('aria-current','step');
        else button.removeAttribute('aria-current');
      });
    }
    function navigate(target) {
      if (!Number.isInteger(target) || target < 1 || target > 4) return;
      if (target > allowedStep()) {
        const next = allowedStep();
        showError(next === 1 ? data.copy.selectFormat : next === 2 ? data.copy.selectFlavor : data.copy.enterName);
        if (next === 3) nameInput.focus();
        else root.querySelector('[data-workout-option="'+(next === 1 ? 'format' : 'flavor')+'"]')?.focus();
        return;
      }
      step = target;
      error.hidden = true; error.textContent = '';
      steps.forEach(panel => { panel.hidden = Number(panel.dataset.workoutStep) !== step; });
      sync();
      root.querySelector('[data-workout-step="'+step+'"] h2')?.focus();
    }
    root.addEventListener('click',event => {
      const button = event.target.closest('button');
      if (!button || !root.contains(button) || button.disabled) return;
      if (button.hasAttribute('data-workout-next')) navigate(step + 1);
      if (button.hasAttribute('data-workout-back')) navigate(step - 1);
      if (button.hasAttribute('data-workout-goto')) navigate(Number(button.dataset.workoutGoto));
    },{signal:controller.signal});
    root.addEventListener('change',event => {
      if (!event.target.matches('[data-workout-option]')) return;
      error.hidden = true; error.textContent = ''; sync();
    },{signal:controller.signal});
    nameInput.addEventListener('input',() => { error.hidden = true; error.textContent = ''; sync(); },{signal:controller.signal});
    nameInput.addEventListener('keydown',event => { if (event.key === 'Enter') { event.preventDefault(); navigate(4); } },{signal:controller.signal});
    controls.forEach(control => { control.disabled = false; });
    steps.forEach(panel => { panel.hidden = Number(panel.dataset.workoutStep) !== 1; });
    root.dataset.ready = 'true';
    sync();
  }
  function rootsWithin(target) {
    const roots = [...target.querySelectorAll('[data-workout-draft]')];
    if (target.matches && target.matches('[data-workout-draft]')) roots.unshift(target);
    return roots;
  }
  const boot = event => rootsWithin(event?.target || document).forEach(mount);
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',event => rootsWithin(event.target).forEach(root => {
    instances.get(root)?.abort(); instances.delete(root); root.removeAttribute('data-ready'); root.removeAttribute('data-selected-variant');
    root.querySelectorAll('button,input').forEach(control => { control.disabled = true; });
  }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mnl-help-center')) {
  customElements.define('mnl-help-center', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.items = [...this.querySelectorAll('details[data-cat]')];
      this.search = this.querySelector('[data-faq-search]');
      this.clearSearch = this.querySelector('[data-faq-clear]');
      this.categories = this.querySelector('[data-faq-categories]');
      this.status = this.querySelector('[data-faq-status]');
      this.empty = this.querySelector('[data-faq-empty]');
      if (!this.search || !this.clearSearch || !this.categories || !this.status || !this.empty) return;
      this.category = 'all';
      const used = new Set();
      this.items.forEach(item => {
        const question = item.querySelector('.mnl-faq__q-text').textContent;
        const stem = question.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,60);
        let slug = stem, suffix = 2;
        while (used.has(slug)) slug = stem + '-' + suffix++;
        used.add(slug);
        const alias = item.previousElementSibling;
        if (alias?.hasAttribute('data-faq-alias') && !document.getElementById('faq-' + slug)) alias.id = 'faq-' + slug;
      });
      const signal = this.events.signal;
      this.categories.addEventListener('click', event => {
        const button = event.target.closest('button[data-cat]');
        if (!button || !this.categories.contains(button)) return;
        this.category = button.dataset.cat; this.filter();
      }, { signal });
      this.search.addEventListener('input', () => this.filter(), { signal });
      this.clearSearch.addEventListener('click', () => {
        this.search.value = ''; this.filter(); this.search.focus();
      }, { signal });
      this.querySelector('[data-faq-reset]').addEventListener('click', () => {
        this.category = 'all'; this.search.value = ''; this.filter(); this.search.focus();
      }, { signal });
      this.addEventListener('toggle', event => {
        const item = event.target;
        if (!item.matches('details[data-cat]')) return;
        item.classList.toggle('is-open', item.open);
        if (!item.open) return;
        try { history.replaceState(history.state, '', '#' + encodeURIComponent(item.id)); } catch {}
      }, { signal, capture:true });
      window.addEventListener('hashchange', () => this.openHash(), { signal });
      this.querySelector('[data-faq-tools]').hidden = false;
      this.filter();
      this.openHash();
    }
    normalize(value) { return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); }
    filter() {
      const query = this.normalize(this.search.value.trim().slice(0,100));
      let visible = 0;
      this.items.forEach(item => {
        item.hidden = (this.category !== 'all' && item.dataset.cat !== this.category) || !this.normalize(item.textContent).includes(query);
        if (!item.hidden) visible++;
      });
      this.categories.querySelectorAll('button[data-cat]').forEach(button => {
        const active = button.dataset.cat === this.category;
        button.setAttribute('aria-pressed', String(active)); button.classList.toggle('is-active', active);
      });
      const template = visible === 1 ? this.status.dataset.templateOne : this.status.dataset.template;
      this.status.textContent = template.replace('[count]',String(visible));
      this.clearSearch.hidden = this.search.value.length === 0;
      this.empty.hidden = visible !== 0;
    }
    openHash() {
      let hash;
      try { hash = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      if (!hash) return;
      const target = document.getElementById(hash);
      if (!target || !this.contains(target)) return;
      const category = target.dataset.faqCategoryAnchor;
      const item = target.matches('details[data-cat]') ? target : target.hasAttribute('data-faq-alias') ? target.nextElementSibling : this.items.find(entry => entry.dataset.cat === category);
      if (!item?.matches('details[data-cat]')) return;
      this.search.value = ''; this.category = item.dataset.cat; this.filter(); item.open = true;
      requestAnimationFrame(() => { if (this.isConnected) item.scrollIntoView({ block:'start', behavior:'instant' }); });
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lab"]) return;
  try {
    
  (() => {
    const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    function init(root) {
      if (!root || root.dataset.ready) return;
      const search = root.querySelector('[data-lab-search]');
      const cards = Array.from(root.querySelectorAll('[data-lab-card]'));
      const filters = Array.from(root.querySelectorAll('[data-lab-filter]'));
      const status = root.querySelector('[data-lab-results]');
      const empty = root.querySelector('[data-lab-empty]');
      let selected = 'all';
      function update() {
        const query = normalize(search.value);
        const words = query.split(' ').filter(Boolean);
        let count = 0;
        cards.forEach(card => {
          const matches = (selected === 'all' || card.dataset.groups.split(' ').includes(selected)) && words.every(word => normalize(card.dataset.search).includes(word));
          card.hidden = !matches;
          if (matches) count += 1;
        });
        status.textContent = `${count} ${count === 1 ? status.dataset.one : status.dataset.many}`;
        empty.hidden = count !== 0;
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.labFilter === selected)));
      }
      filters.forEach(button => button.addEventListener('click', () => { selected = button.dataset.labFilter; update(); }));
      search.addEventListener('input', update);
      root.querySelector('[data-lab-reset]').addEventListener('click', () => { selected = 'all'; search.value = ''; update(); search.focus(); });
      function followHash(focusTarget = false) {
        let id;
        try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const found = document.getElementById(id);
        if (!found || !root.contains(found)) return;
        const card = found.closest('[data-lab-card]');
        const target = card || (found.classList.contains('mlab-anchor') ? found.parentElement : found);
        if (card) {
          selected = 'all'; search.value = ''; update();
          const details = card.querySelector('details');
          if (details) details.open = true;
        }
        if (target.id === 'lab-sources') target.querySelector('details').open = true;
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
        if (focusTarget) { target.tabIndex = -1; target.focus({preventScroll:true}); }
      }
      window.addEventListener('hashchange', () => followHash());
      root.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !root.contains(target)) return;
        event.stopPropagation();
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        event.preventDefault();
        history.pushState(history.state, '', link.hash);
        followHash(true);
        root.querySelectorAll('.mlab-nav a').forEach(item => item.setAttribute('aria-current', item.hash === link.hash ? 'location' : 'false'));
      });
      root.querySelector('[data-lab-controls]').hidden = false;
      status.hidden = false;
      const demo = root.querySelector('[data-lab-demo]');
      demo.querySelector('[data-lab-demo-controls]').hidden = false;
      demo.querySelectorAll('[data-lab-mix]').forEach(button => button.addEventListener('click', () => {
        const neutral = button.dataset.labMix === 'neutral';
        demo.querySelectorAll('[data-lab-mix]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        demo.querySelector('[data-lab-active-weight]').textContent = neutral ? '500 g' : '400 g';
        demo.querySelector('[data-lab-flavour-weight]').textContent = neutral ? '0 g' : '100 g';
        demo.querySelector('[data-lab-active-bar]').style.width = neutral ? '100%' : '80%';
        demo.querySelector('[data-lab-flavour-bar]').style.width = neutral ? '0%' : '20%';
      }));
      root.dataset.ready = 'true';
      update(); followHash();
    }
    document.querySelectorAll('[data-lab-studio]').forEach(init);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-lab-studio]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
